<template>
<div>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-2" style="height:64px">
         <div style="width:86%;"> 
            <div class="w-100">
              <div class="d-inline-flex edit-icon-visibility">
                <div style="display:flex;width:100%;">
                  <span :title="getSlugName()" class="review-header" style="font-size:28px;display: inline-block;margin-inline-end:10px;word-break: break-word;white-space: nowrap; max-width: 90%;
                    overflow: hidden;
                    text-overflow: ellipsis;">{{getSlugName()}}</span>
    
                </div>
              </div>
            </div>
          </div> 
          <div class="primary-btn-style">
            <button style="width: 105px;" :title="$t('Export as FCPXML')" class="btn btn-primary m-2 ml-3" @click="exportGrowingMediaComment()">{{$t('Export')}}</button>
          </div>
          <div style="display:flex">
            <div style="display: flex;align-items: center;">
              <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeModal()">  
                  <span aria-hidden="true">
                      <CancelIcon class="close-icon" style="height: 40px !important;width: 40px !important;color: #fff;"/>
                  </span>
              </button>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="review-annotation-wrapper">
            <div class="video_annotation_wrapper row">
                  <div class="video_wrapper col-md-8 p-0">
                      <template v-if="isPlayerLoaded">
                        <!-- <div style="width:100%;position:relative;height:60%;" :style="!isCommentTextboxVisible?'height:84% !important;':''"> -->
                             <div class="video-player-wrapper-div" style="position:relative;" v-show="!isAnnotationEditorVisible && isPlayerInitialized">
                                  <video-player @hook:mounted="handleVideoPlayerMounted" ref="videoPlayerRef" :playerId="'reviewVideoPlayer'" @controller="setController" @metaDataLoaded="videoPlayerMetadataLoaded()" v-show="!isAnnotationEditorVisible && isPlayerInitialized" :options="videoOptions" style="height:90%;width:100%"/>  <!-- class="video-player-wrapper-div" -->
                                   <div style="position: absolute; top: 13px; inset-inline-end :13px;" v-if="(isImageAnnotation) || ((isCommentWithFrameVisible || isCommentWithSegmentMarkinMarkout) && !isAnnotationEditorVisible)">
                                        <button style="font-size:16px;" :title="$t('Comment')" id="commentAnnotateBtn" ref="commentAnnotateBtn" @click="!isImageAnnotation?(handleAnnotateClick(),captureVideoCanvas()) : handleImageAnnotateClick()" class="btn btn-lg btn-primary"> <!-- :class="(isCommentWithFrameVisible || (isCommentWithSegmentMarkinMarkout && markinMakoutValues.mark_out > 0))?'active-pulsate-btn':''" -->
                                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-brush-fill svg-tools-color" viewBox="0 0 16 16" style="fill:currentColor !important;">
                                              <path d="M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.067 6.067 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.118 8.118 0 0 1-3.078.132 3.659 3.659 0 0 1-.562-.135 1.382 1.382 0 0 1-.466-.247.714.714 0 0 1-.204-.288.622.622 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896.126.007.243.025.348.048.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04z"/>
                                              <title>{{$t('Annotate')}}</title>
                                            </svg>
                                            <span class="button-with-text--text">
                                                {{$t('Annotate')}}
                                            </span>
                                          </button>
                                   </div>
                             </div>
                        <!-- </div> -->
                      </template>
                      <template v-if="isShowingLoadingDiv">
                         <div style="width:100%;height:100%;" class="video-player-wrapper-div player-loading-progress-div" v-if="!isPlayerInitialized">{{$t('Loading')}} ....</div>
                      </template>
                      <template v-if="!isImageAnnotation">
                         <tui-image-editor class="fusion-tui-image-editor-main-wrapper" :class="!isAnnotationEditorVisible ? 'editor-full-height' : 'editor-height-with-panel'" v-if="isAnnotationEditorVisible" @TUIimageEditorMounted="relocateToolsBars()" :include-ui="useDefaultUI" ref="tuiImageEditor" :options="options"></tui-image-editor>
                      </template>
                      <template v-else>
                           <div class="image-image-annotation-wrapp video-player-wrapper-div" style="position:relative;text-align: center;" :style="!(isImageAnnotationFullScreen && isAnnotationEditorVisible) ? 'display: flex; justify-content: center; align-items: center;':''">
                             <tui-image-editor class="fusion-tui-image-editor-main-wrapper" v-if="isImageAnnotationFullScreen && isAnnotationEditorVisible" style="max-width: 100%;" :class="isImageAnnotationFullScreen ? 'editor-height-with-panel' : ''" @TUIimageEditorMounted="relocateToolsBars()" :include-ui="useDefaultUI" ref="tuiImageEditor" :options="options"></tui-image-editor>
                             <img v-else :src="getProxyConvertedURL(options.includeUI.loadImage.path)" style="max-width: 100%; max-height: 100%;"/>
                            <div style="position: absolute; top: 13px; inset-inline-end :13px;" v-if="!isImageAnnotationFullScreen">
                                <button style="font-size:16px;" title="Comment" id="commentAnnotateBtn" ref="commentAnnotateBtn" @click="handleAnnotateOrImage" class="btn btn-lg btn-primary"> <!-- :class="(isCommentWithFrameVisible || (isCommentWithSegmentMarkinMarkout && markinMakoutValues.mark_out > 0))?'active-pulsate-btn':''" -->
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-brush-fill svg-tools-color" viewBox="0 0 16 16" style="fill:currentColor !important;">
                                      <path d="M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.067 6.067 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.118 8.118 0 0 1-3.078.132 3.659 3.659 0 0 1-.562-.135 1.382 1.382 0 0 1-.466-.247.714.714 0 0 1-.204-.288.622.622 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896.126.007.243.025.348.048.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04z"/>
                                      <title>{{$t('Annotate')}}</title>
                                    </svg>
                                    <span class="button-with-text--text">
                                        {{$t('Annotate')}}
                                    </span>
                                  </button>
                              </div>
                           </div>
                      </template>

                      <div class="row video-control-wrapper d-flex justify-content-between" v-if="(!isImageAnnotation && !isEditorToolsWrapperVisible)||(isImageAnnotation && !isImageAnnotationFullScreen)">  <!-- v-if="!isEditorToolsWrapperVisible" -->
                        <div class="left-control-wrapper" :style="isImageAnnotation?'visibility:hidden;':''">
                          <button :title="$t('Toggle Play-Pause')+'(spacebar)'" @click="togglePlayPause()" style="min-width: 40px; display: none; align-items: center;justify-content:center;" class="btn btn-outline-secondary play common-markinmarkout-action-btn">  
                            <span v-show="isPlaying" class="common-play-pause"><svg style="width:32px;height:32px;" xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 24 24" width="30px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg></span>
                            <span v-show="!isPlaying" class="common-play-pause"><svg  style="width:32px;height:32px;" xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 24 24" width="30px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"/></svg></span>
                          </button>
                          <VideoActionsButtons @forwardBackwardVideoBy1Sec="forwardBackwardVideoBy1Sec" @forwardBackwardVideoByFrame="forwardBackwardVideoByFrame">
                                  <template slot="playPauseButton" v-if="isVideoType">
                                     <button :title="$t('Toggle Play-Pause')+'(spacebar)'" @click="togglePlayPause()" style="min-width: 40px; display: flex; align-items: center;justify-content:center;" class="btn btn-outline-secondary play common-markinmarkout-action-btn">  
                                        <span v-show="isPlaying" class="common-play-pause"><svg style="width:32px;height:32px;" xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 24 24" width="30px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg></span>
                                        <span v-show="!isPlaying" class="common-play-pause"><svg  style="width:32px;height:32px;" xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 24 24" width="30px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"/></svg></span>
                                      </button>
                                  </template>
                             </VideoActionsButtons>
                        </div>
                        <div class="markin-markout-with-comments">
                              <div class="center-duration-display markin-markout-with-segment" v-if="isCommentWithSegmentMarkinMarkout">
                                    <div class="input-group markin">
                                        <div class="input-group-prepend" @click="captureMarkin()" :title="$t('Capture Markin')+' (i)'">
                                          <span class="input-group-text" id="markin-add-on"><img src="~@/assets/markin_dark.png"/></span>
                                        </div>
                                        <input type="text" :class="markinMakoutValues.mark_in !=null && markinMakoutValues.mark_in > -1 ? 'active-markin-markout-duration':''" ref="markinDurationRef" @blur="handleMarkinInputBlur($event)" data-type="markin" @input="isValidDuration($event)" class="form-control common-markin-markout-input" :value="markinDurationValue" placeholder="00:00:00" aria-label="Markin" aria-describedby="markin-add-on">
                                    </div>
                                    <div class="input-group markout">
                                        <input type="text" id="markout_input_ref" data-type="markout" :class="markinMakoutValues.mark_out !=null && markinMakoutValues.mark_out > -1 ? 'active-markin-markout-duration':''" class="form-control common-markin-markout-input" @click="isTourRequired = false;" @input="isValidDuration($event)"  ref="markoutDurationRef" @blur="showPreviewButtonOnBlur($event)" :value="markoutDurationValue" :placeholder="markoutPlaceholderValue" aria-label="Markout" aria-describedby="markout-add-on">
                                        <div class="input-group-append" :class="markinMakoutValues.mark_out <= 0 ? 'is-markout-not-added':''" @click="captureMarkout()" :title="$t('Capture Markout')+' (o)'">
                                          <span class="input-group-text" id="markout-add-on"><img src="~@/assets/markout_dark.png"/></span>
                                        </div>
                                    </div>
                              </div>
                             
                            <div class="comment-without-frame" commenthhh v-if="(!isImageAnnotation && !isCommentWithSegmentMarkinMarkout && !isCommentWithFrameVisible && !isOnlyCommentButtonActive) || (isImageAnnotation && !isOnlyCommentButtonActive && !isImageAnnotationFullScreen)">
                                <button style="padding: 2px 10px;" :title="$t('comment for file')" class="btn" @click.prevent.stop="handleOnlyCommentclick()" :class="isOnlyCommentButtonActive ? 'btn-outline-primary':'btn-outline-secondary'">
                                       <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="32" height="32" viewBox="0 0 32 32">
                                          <path d="M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"/>
                                          <polygon points="17 9 15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9"/>
                                        </svg>
                                       <span class="button-with-text--text" style="display:none;">
                                          {{$t('Comment')}}
                                       </span>
                                </button>
                            </div>
                            <div class="comment-with-segement-markin-markout" v-if="!isCommentWithFrameVisible && !isOnlyCommentButtonActive && !isImageAnnotation">
                                  <div class="button-with-text" v-if="!isCommentWithSegmentMarkinMarkout">
                                       <button style="padding: 2px 10px;" :title="$t('comment for segment')" @click.prevent.stop="handleCommentWithSegmentClick()"  class="btn" :class="isCommentWithSegmentMarkinMarkout? 'btn-outline-primary' : 'btn-outline-secondary'">
                                          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="32" height="32" viewBox="0 0 32 32">
                                            <path d="M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"/>
                                            <polygon points="17 9 15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9"/>
                                          </svg>
                                          <span class="button-with-text--text">
                                              {{$t('Segment')}}
                                          </span>
                                       </button>
                                </div>
                                <div class="button-with-text" v-if="isCommentWithSegmentMarkinMarkout && markinMakoutValues.mark_in != null && markinMakoutValues.mark_in > -1 && markinMakoutValues.mark_out != null && markinMakoutValues.mark_out > -1 && markinMakoutValues.mark_out != markinMakoutValues.mark_in">
                                    <button class="secondary-default edit-icon btn" :title="$t('Preview Markin-Markout region')+' (p)'" style="min-width: 40px; display: flex; align-items: center;justify-content:center;height:30px;font-size: 14px !important; font-weight: 100;" :class="isActivePreview ? 'btn-outline-primary' : 'btn-outline-secondary'" @click.prevent.stop="playMarkinMarkoutPreview()">
                                      <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 6.5c3.79 0 7.17 2.13 8.82 5.5-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5z"/></svg>
                                    </button>
                                </div>
                            </div>

                           <div class="comment-with-frame" v-if="!isCommentWithSegmentMarkinMarkout && !isOnlyCommentButtonActive && !isImageAnnotation">
                                <div class="button-with-text" v-if="!isCommentWithFrameVisible">
                                    <button style="padding: 2px 10px;" :title="$t('comment for frame')" @click.prevent.stop="handleCommentWithFrameClick()" class="btn btn-primary" :class="!isCommentWithFrameVisible?'active-pulsate-btn':''"> <!-- :class="isCommentWithFrameVisible ? 'btn-outline-primary':'btn-outline-secondary'" -->
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="32" height="32" viewBox="0 0 32 32">
                                        <path d="M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"/>
                                        <polygon points="17 9 15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9"/>
                                      </svg>
                                      <span class="button-with-text--text">
                                          {{$t('Frame')}}
                                      </span>
                                    </button>
                                </div>
                                <div class="button-with-text" v-if="isCommentWithFrameVisible">
                                    <button style="padding: 2px 10px;" :title="$t('Re-capture frame')" @click.prevent.stop="handleCommentWithFrameClick()" class="btn btn-outline-secondary" :class="!isCommentWithFrameVisible?'active-pulsate-btn':''"> <!-- :class="isCommentWithFrameVisible ? 'btn-outline-primary':'btn-outline-secondary'" -->
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16" class="bi bi-film" viewBox="0 0 16 16" style="width: 16px !important; height: 16px !important;">
                                        <path d="M0 1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm4 0v6h8V1zm8 8H4v6h8zM1 1v2h2V1zm2 3H1v2h2zM1 7v2h2V7zm2 3H1v2h2zm-2 3v2h2v-2zM15 1h-2v2h2zm-2 3v2h2V4zm2 3h-2v2h2zm-2 3v2h2v-2zm2 3h-2v2h2z"/>
                                      </svg>
                                      <span class="button-with-text--text">
                                          {{$t('Re-capture')}}                           
                                      </span>
                                    </button>
                                </div>
                            </div>

                            <div v-if="isOnlyCommentButtonActive || isCommentWithFrameVisible || isCommentWithSegmentMarkinMarkout" class="cancel-button-for-all">
                                <button :title="$t('Cancel')"  @click.prevent.stop="handleCancelButtonClick()" class="btn btn-outline-secondary">
                                        <!-- <svg  height="32px" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="bi bi-x"><path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path></svg> -->
                                        <span class="button-with-text--text">
                                          {{$t('Cancel')}}
                                        </span>
                                </button>
                            </div>
                        </div>
                        
                        <div v-if="isCommentWithFrameVisible" class="frame-time-code-show">
                           <div class="frame-capture-timecode">{{getCapturedTimeline()}}</div>
                        </div>

                        <!---
                        <div class="right-control-wrapper mr-2">
                          <template v-if="isMarkoutValueAdded">
                            <button class="btn btn-outline-secondary" title="Clear Markin-Markout region (c)" @click="clearMarkinMarkout()" style="min-width: 40px; display: flex; align-items: center; justify-content: center; height: 30px; font-size: 14px !important; font-weight: 100;">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                                <title>Clear</title>
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                              </svg>
                              {{$t('Clear')}}
                            </button>
                            <button class="secondary-default edit-icon btn" title="Preview Markin-Markout region (p)" style="min-width: 40px; display: flex; align-items: center;justify-content:center;height:30px;font-size: 14px !important; font-weight: 100;" :class="isActivePreview ? 'btn-outline-primary' : 'btn-outline-secondary'" @click="playMarkinMarkoutPreview()">
                              <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 6.5c3.79 0 7.17 2.13 8.82 5.5-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5z"/></svg>
                              <span style="margin-inline-start: 3px;font-size: 14px !important;">Preview</span>
                            </button>
                          </template>
                          <button class="secondary-default edit-icon btn btn-outline-secondary" style="min-width: 40px; display: flex; align-items: center;justify-content:center;height:30px;" @click="captureVideoCanvas()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-brush-fill svg-tools-color" viewBox="0 0 16 16" style="fill:currentColor !important;">
                              <path d="M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.067 6.067 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.118 8.118 0 0 1-3.078.132 3.659 3.659 0 0 1-.562-.135 1.382 1.382 0 0 1-.466-.247.714.714 0 0 1-.204-.288.622.622 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896.126.007.243.025.348.048.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04z"/>
                              <title>Annotate (a)</title>
                            </svg>
                          </button>
                        </div> -->
                    </div>

                    <div class="send-review-messages m-0 disable-text-editor" v-show="(isImageAnnotation && !isImageAnnotationFullScreen) || (!isImageAnnotation && ((!isAnnotationEditorVisible && isVideoType) || (!isVideoType && isAnnotationEditorVisible)))" :class="(isAnnotationEditorVisible && isImageType) ? 'image-review-display' : ''">
            <!--           <div v-show="isAnnotatedImageVisible">
                        <div class="d-flex">
                          <div class="commentedOn-duration">
                             {{getDuration()}}
                          </div>
                          <div class="commentedOn-duration">
                            0:21:00
                          </div>
                        </div>
                        <div class="markinMarkoutImageWrapperINReplyThread" style="width: 185px !important;height: 120px !important;margin:1px;">
                          <img draggable="false" :src="annotatedImage"  @error="replaceByDefaultImage" style="margin: 0px !important;display: block;max-width: 320px;max-height: 180px;width: auto;height: auto;width:100%;height:100%;"/> 
                        </div>
                      </div> -->
                      <div style="width: -webkit-fill-available;position:relative;" class="text-editor-background-image main-comment-wrapper" ref="mainCommentWrapper_withImage" :data-url="null">
                        <chatTextArea ref="primaryCommentTextFromTextarea"
                         @messageText="addCommentToReview" 
                         :usersList="getUsersListToMention(reviewInfo.asset_comments)" 
                         :customStylesTextarea="{'placeholderName':'Add comment...','disabledActions':['attach-tasks'],'displayOnlyAttachedFileName':true}"
                         v-click-outside="closeOpenedMentionsDopdown" 
                         :closeMentions="closeMentions" 
                         @openPipOfSelectedFile="openFilePreview"
                         @hook:mounted="blurFocusFromTextarea()"
                         :class="((isOnlyCommentButtonActive || isCommentWithFrameVisible || (isCommentWithSegmentMarkinMarkout && markinMakoutValues.mark_in != null && markinMakoutValues.mark_in > -1 && markinMakoutValues.mark_out != null && markinMakoutValues.mark_out > -1 && markinMakoutValues.mark_in !== markinMakoutValues.mark_out)) && !isAnnotationEditorVisible && !isImageAnnotation) || (!isImageAnnotation && isAnnotationEditorVisible && isImageOnlyFinalStep) || (isImageAnnotation && !isImageAnnotationFullScreen && isOnlyCommentButtonActive ) ? 'final-step-send-comment' : ''"
                         ></chatTextArea>
                      </div>
                    </div>

                  </div>
                  <div class="live-comment-wrapper col-md-4 p-0 h-100">
                    <!-- <div class="navbar-wrapper">
                        <nav class="navbar navbar-expand-lg p-0">
                            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                                <div class="navbar-nav w-100 top-nav-bar">
                                    <a class="nav-item nav-link" @click='switchDetailsAndCommentTab("comments")' :class='(activeIndex === "comments")?"active":"inactive"' style="width:33% !important;text-align: center;">{{$t('Comments')}}</a>
                                    <a class="nav-item nav-link" @click='switchDetailsAndCommentTab("description")' :class='(activeIndex === "description")?"active":"inactive"' style="width:33% !important;text-align: center;">{{$t('Description')}}</a>
                                    <a class="nav-item nav-link" @click='switchDetailsAndCommentTab("fields")' :class='(activeIndex === "fields")?"active":"inactive"' style="width:33% !important;text-align: center;">{{$t('Fields')}}</a>
                                </div>
                            </div>
                        </nav>
                    </div> -->
                    <div style="height: 90%;">
                      <div v-if="activeIndex == 'comments'" ref='mainCommentsWrapper' class="comment-scroll-main-wrapper" style="height: 100%;">
                        <div style="height: calc(100vh - 64px);overflow: auto;">
                          <template v-if="reviewInfo && 'comments' in reviewInfo && reviewInfo.comments.length > 0">
                            <template v-for="comment in reviewInfo.comments">
                              <div :key="`${comment._id}`" :data-id="comment._id" class="comment-row-wrapper" :class="{'active-commentRow':selectedCommentId == comment._id}">
                                <CommentsThread :isRepliedRequired="false" :key="comment._id" :ref="comment._id" :data-id="comment._id" :reviewInfo="reviewInfo" :commentData="comment" :selectedCommentRowID="selectedCommentId" :enableEditParentTextIDProp="isEditCommentID" :repliedCommentslist="repliedCommentslist" @messageText="addReplyCommentToReview" @editCommentText="editCommentText" @showRepliesOfComment="showRepliesOfComment" @deleteRepliedComment="deleteSelectedComment" @cancelEditField="cancelEditField"  @commentStatusUpdate="updateOnlyCommentStatus" @click.native="selectedCommentInfo = comment; showTimelineMarker(comment)" @openPictureInPicture="openPictureInPicture"></CommentsThread>
                              </div>
                            </template>
                            <template v-if="paginationInfo.page < paginationInfo.page_count">
                                 <div class="show-load-more-page" style="width: 100%;text-align: center;padding: 10px;">
                                    <template v-if="(paginationInfo.total_asset_comments - paginationInfo.asset_comments_per_page * paginationInfo.page) > paginationInfo.asset_comments_per_page">
                                       <button class="btn btn-outline-primary btn-block" @click="loadMoreComments()">{{$t('Load more comments')}}</button>
                                    </template>
                                    <template v-else>
                                        <button class="btn btn-outline-primary btn-block" @click="loadMoreComments()">{{$t('Load')}} {{paginationInfo.total_asset_comments - paginationInfo.asset_comments_per_page * paginationInfo.page}} {{$t('more comments')}}</button>
                                    </template>
                                 </div>
                            </template>
                          </template>
                          <div v-else class="outer">
                            <div class="middle">
                              <div class="inner">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#44a1da" style="opacity:0.4" class="bi bi-chat" viewBox="0 0 16 16">
                                  <path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"/>
                                </svg>
                                <p>{{$t('No comments yet')}}!!</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <canvas id="captureVideoFrame"></canvas> -->
  <ImagePreviewDialog class="hide-element-util-mount" :isDialgMinimizeIconRequired="false"  :selectedFile="assetDetailsToShowPip" @closeMiniPlayer="isImagePreviewDialogOpened = false" v-if="isImagePreviewDialogOpened"></ImagePreviewDialog>
  <!-- manage version -->
  <picture-in-picture v-if="openPip" :selectedFile="assetDetailsToShowPip" @closeMiniPlayer="closeMinimisedPlayer"></picture-in-picture>
  <v-tour v-if="isTourRequired" name="createReviewUserTour" :steps="steps" :options="tourOptions" v-click-outside="closeValidationErrorDialog" />
  <ExportGrowingMediaComment :fileInfo="assetDetails" :projectName="getSlugName()" @close="isExportMediaOpened = false" v-if="isExportMediaOpened"></ExportGrowingMediaComment>
</div>
</template>

<script>
import CancelIcon from "../core/InlineCancelField.vue";
import VideoPlayer from "../core/VideoPlayer.vue";
import Utils from "../../components.utils.js";
import {mapActions,mapGetters,mapMutations} from 'vuex';
import ImageEditor from '../core/Tui-ImageEditorComponent.vue';
import miniPlayer  from '../files/MiniPlayer.vue';
import chatTextArea from '../core/ChatTextarea.vue';
import CommentsThread from './ReviewCommentsThread.vue';
import Constants from "../../components.constants.js";
import ImagePreviewDialog from '../core/ImagePreviewDialog.vue';
import ExportGrowingMediaComment from './exportMedia.vue';
import VideoActionsButtons from './VideoActionsButtons.vue';
export default {
   name:'GrowingMediaComments',
   props:['fileInfo','enableEditMode','reviewId','mediapipeline_closewithEmit'],
   components:{VideoPlayer,CancelIcon,'tui-image-editor':ImageEditor,chatTextArea,CommentsThread,ImagePreviewDialog,'picture-in-picture':miniPlayer, ExportGrowingMediaComment, VideoActionsButtons},
   data(){
       return {
          isShowingLoadingDiv: true,
          isImageAnnotation:false,
          isPlayerLoaded:false,
          videoFrameRate:25,
          isUsersBrowseEnabled:false,
          isEditorToolsWrapperVisible:false,
          isAnnotationEditorVisible: false,
          controller:{},
          videoOptions: {
            autoplay: false,
            controls: true,
            nativeTextTracks: true,
            controlBar: {
              'pictureInPictureToggle': false,
              volumePanel: {
                inline: false,
                vertical: true
              }
            },
            sources: []
          },
          useDefaultUI: true, 
          options: {
              // for tui-image-editor component's "options" prop
              includeUI:{
                loadImage: {
                        path: null,
                        name: 'My image',
                }, 
                uiSize: {
                    width: null,
                    height: null
                },
                imageSize:{
                   width:null,
                   height:null
                },
                // menu: ['flip','rotate','shape','icon', 'text', 'draw'],
                menu: ['shape','icon', 'text', 'draw'],
                initMenu: 'draw',
                menuBarPosition:   "left",
              },
              usageStatistics: false,
          },
          parentRouteInfo:{},
          reviewInfo:{comments:[]},
          primaryCommentText:"",
          activeIndex: "comments",
          selectedCommentId: null,
          repliedCommentslist: [],
          annotatedImage:null,
          isAnnotatedImageVisible: false,
          isPlaying:false,
          isPlayerInitialized: false,
          isActivePreview:false,
          isMarkoutValueAdded:false,
          markoutDurationValue:'',
          markinDurationValue:'',
          markoutPlaceholderValue:'00:00:00',
          isMarkinButtonClicked: false,
          markinMakoutValues:{mark_in:null,mark_out:null},
          isEditComment:false,
          isEditCommentID:null,
          isImagePreviewDialogOpened: false,
          isCommentMarkinMarkoutPreview: false,
          closeMentions:false,
          isAnnotationCaptured: false,
          imagePreviewFileObj: {},
          openManageVersionsDialog:false,
          markinUniqueId:null,
          selectedCommentInfo:{},
          assetDetailsToShowPip:{},
          openPip:false,
          showOtherFilesPreviewDialog:false,
          isCommentTextboxVisible:false,
          isOnlyCommentButtonActive:false,
          isCommentWithFrameVisible:false,
          isCommentWithSegmentMarkinMarkout:false,
          isTourRequired:false,
          tourOptions: {
            useKeyboardNavigation: false
          },
          isImageOnlyFinalStep: false,
          isImageAnnotationFullScreen:false,
          steps: [
            {
              target: "#markout_input_ref", // or use a class/id
              content: `
              <div style="display:flex;gap:13px;">
                <div>
                   <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                    <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
                    <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
                  </svg>
                </div>
                <div>Markout not added. Please add markout</div>
              </div>`,
              params: {
                placement: 'top'
              }
            }
          ],

          assetDetails : {},
          isExportMediaOpened: false,
          dataStructureList:["_id","created_by_id","status","comment_type","comment","pid","markers"],
          paginationInfo:{asset_comments_per_page:null,page:null,page_count:null,total_asset_comments:null},
          page:1,
       }
   },
   watch:{
    isCommentWithSegmentMarkinMarkout:{
        immediate:true,
        handler(newVal){
            if(!newVal){
                this.isTourRequired = false;
            }
        }
    },
    "$refs.primaryCommentTextFromTextarea.browserType":function(newVal){
        console.log('inside $refs.primaryCommentTextFromTextarea.browserType',newVal);
        if(newVal == 'fusion'){
            this.$refs.videoPlayerRef.$el.classList.add('hide-video-on-browse-open');
        }else{
           this.$refs.videoPlayerRef.$el.classList.remove('hide-video-on-browse-open');
        }
    }
  },
   methods:{
    getSeekbarTime() {
        const progressControl = this.controller.player.controlBar.progressControl;
        const seekBar = progressControl?.seekBar;
        
        if (!seekBar) {
            console.warn('Seekbar not found');
            return this.controller.player.currentTime();
        }
        
        const dur = this.controller.player.duration();
        const isLive = dur === Infinity;
        
        if (isLive) {
            // For live streams, use currentTime (which represents where playhead is)
            // NOT getPercent() which can change as seekable range shifts
            const currentTime = this.controller.player.currentTime();
            
            const seekable = this.controller.player.seekable();
            
            if (seekable.length > 0) {
                const seekableStart = seekable.start(0);
                const seekableEnd = seekable.end(0);
                
                // Validate current position is within seekable range
                if (currentTime >= seekableStart && currentTime <= seekableEnd) {
                    console.log('Current playhead time:', {
                        time: currentTime.toFixed(2),
                        seekableRange: `${seekableStart.toFixed(2)} - ${seekableEnd.toFixed(2)}`
                    });
                    
                    return currentTime;
                } else {
                    console.warn('Current time outside seekable range');
                    // Clamp to seekable range
                    return Math.max(seekableStart, Math.min(currentTime, seekableEnd));
                }
            }
        }
        
        // For VOD, just use current time
        return this.controller.player.currentTime();
    },
    forwardBackwardVideoByFrame(type) {
        if (!type) {
            console.log("Invalid type");
            return false;
        }
        
        if (!this.controller.player) {
            return false;
        }
        
        const frameTime = 0.04; // ~1 frame at 25fps
        let dur = this.$refs.videoPlayerRef.getPlayerLiveDuration();//this.controller.player.duration();
        let curDur = this.controller.player.currentTime();
        
        // Handle live streams
        let isLive = dur === Infinity;
        let maxTime, minTime;
        
        if (isLive) {
            // For live streams, use seekable range
            let seekable = this.controller.player.seekable();
            if (seekable.length > 0) {
                minTime = seekable.start(0);
                maxTime = seekable.end(0);
            } else {
                console.warn('No seekable range available for live stream');
                return false;
            }
        } else {
            // For VOD
            minTime = 0;
            maxTime = dur;
        }
        
        if (curDur == undefined || maxTime == undefined) {
            return false;
        }
        
        // Pause the video for frame-by-frame control
        const wasPlaying = !this.controller.player.paused();
        if (wasPlaying) {
            this.controller.player.pause();
        }
        
        // Forward one frame
        if (type == "forward") {
            let newTime = curDur + frameTime;
            
            // Don't exceed max time
            if (newTime <= maxTime) {
                this.controller.player.currentTime(newTime);
            } else if (!isLive) {
                // For VOD, go to end
                this.controller.player.currentTime(maxTime);
            }
        }
        
        // Backward one frame
        if (type == "backward") {
            let newTime = curDur - frameTime;
            
            // Don't go below min time
            if (newTime >= minTime) {
                this.controller.player.currentTime(newTime);
            } else {
                // Go to start
                this.controller.player.currentTime(minTime);
            }
        }
        
        // Force a visual update by seeking to a slightly different time and back
        // This helps with HLS streams that might not update on small seeks
        if (isLive || this.src?.includes('.m3u8')) {
            setTimeout(() => {
                const currentPos = this.controller.player.currentTime();
                this.controller.player.currentTime(currentPos + 0.001);
                setTimeout(() => {
                    this.controller.player.currentTime(currentPos);
                }, 10);
            }, 10);
        }
    },
    forwardBackwardVideoBy1Sec(action) {
        if (!action) {
            console.log("Invalid action");
            return false;
        }
        
        if (!this.controller.player) {
            return false;
        }
        
        const seekTime = 1; // 1 second
        let dur = this.$refs.videoPlayerRef.getPlayerLiveDuration();//this.controller.player.duration();
        let curDur = this.controller.player.currentTime();
        
        // Handle live streams
        let isLive = dur === Infinity;
        let maxTime, minTime;
        
        if (isLive) {
            // For live streams, use seekable range
            let seekable = this.controller.player.seekable();
            if (seekable.length > 0) {
                minTime = seekable.start(0);
                maxTime = seekable.end(0);
            } else {
                console.warn('No seekable range available for live stream');
                return false;
            }
        } else {
            // For VOD
            minTime = 0;
            maxTime = dur;
        }
        
        if (curDur == undefined || maxTime == undefined) {
            return false;
        }
        
        // Forward 1 second
        if (action == "forward") {
            let newTime = curDur + seekTime;
            
            // Don't exceed max time
            if (newTime < maxTime) {
                this.controller.player.currentTime(newTime);
            } else if (!isLive) {
                // For VOD, go to end
                this.controller.player.currentTime(maxTime);
            }
        }
        
        // Backward 1 second
        if (action == "backward") {
            let newTime = curDur - seekTime;
            
            // Don't go below min time
            if (newTime > minTime) {
                this.controller.player.currentTime(newTime);
            } else {
                // Go to start
                this.controller.player.currentTime(minTime);
            }
        }
    },
    loadMoreComments(){
          let payload = {params:{"asset_id":this.assetDetails._id,comment_type:"Asset Comment",page:this.paginationInfo.page + 1}};
          this.getGrowingMediaComments(payload).then((data)=>{
            console.log("[loadMoreComments]",data);
            this.reviewInfo.comments.push(...data.asset_comments);
            for(let key in data){
                 if(Object.prototype.hasOwnProperty.call(this.paginationInfo,key)){
                     this.paginationInfo[key] = data[key];
                 }
            }
            //this.setCommentsMarkers(this.getMarkersList(this.reviewInfo.comments));
        });
      },
      isAllMinimumDataStructureKeysPresent(upsertedData){
          if(upsertedData){
             for(let i = 0; i < this.dataStructureList.length; i++){
               if(!Object.prototype.hasOwnProperty.call(upsertedData,this.dataStructureList[i])){
                  return false;
               }
             }
          }
         return true;
      },
      exportGrowingMediaComment(){
          this.isExportMediaOpened = true;
      },
      getSlugName(file){
         if(!file){
           file = this.assetDetails;
         }
         if(file && Object.prototype.hasOwnProperty.call(file,'slug_name')){
            return file.slug_name;
         }
         return file.file_name;
      },
      handleAnnotateOrImage() {
        if (!this.isImageAnnotation) {
          this.handleAnnotateClick()
          this.captureVideoCanvas()
        } else {
          this.handleImageAnnotateClick()
        }
      },
      handleImageAnnotateClick(){
         this.isImageAnnotationFullScreen = true;
      },
      handleVideoPlayerMounted(){
        setTimeout(()=>{
             this.isPlaying = !this.$refs.videoPlayerRef.player.paused();
        },900);
      },
      getCapturedTimeline(){
         return Utils.getExactDuationInSeconds(this.markinMakoutValues.mark_in,this.videoFrameRate,'.');
      },
      blurFocusFromTextarea(){
         this.$nextTick(()=>{
               this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea').blur();
         });
      },
      closeValidationErrorDialog(){
         this.isTourRequired = false;
      },
      handleAnnotateClick(){
        if(this.isCommentWithFrameVisible)
             this.markinMakoutValues.mark_in = this.controller.player.currentTime();
      },
      handleCancelButtonClick(){
          if(this.$refs.primaryCommentTextFromTextarea && String(this.$refs.primaryCommentTextFromTextarea.commentText).length > 1){
              if(!confirm("A comment is present. Are you sure you want to discard it?")){
                  this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea').focus();
                  return;
              }
          }
          this.$refs.primaryCommentTextFromTextarea.commentText = "";
          this.markinMakoutValues.mark_in = null;
          this.markinMakoutValues.mark_out = null;
          this.isOnlyCommentButtonActive = false;
          this.isCommentTextboxVisible = false;
          this.isCommentWithFrameVisible= false;
          this.isCommentWithSegmentMarkinMarkout= false;
          this.resetMarkinMarkout();
          this.removeMarkersElement();
          this.annotatedImage = null;
          this.isAnnotatedImageVisible = false;
          this.removeAnnotationThumbnailDisplay();
          this.$el.querySelector('.send-review-messages').classList.add('disable-text-editor');
      },
      handleOnlyCommentclick(){
          this.markinMakoutValues.mark_in = null;
          this.markinMakoutValues.mark_out = null;
          this.annotatedImage = null;
          this.isOnlyCommentButtonActive = true;//!this.isOnlyCommentButtonActive;
          this.isCommentTextboxVisible = this.isOnlyCommentButtonActive;
          this.isCommentWithFrameVisible= false;
          this.isCommentWithSegmentMarkinMarkout= false;
          this.$el.querySelector('.send-review-messages').classList.remove('disable-text-editor');
          this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea').focus();
      },

      handleCommentWithFrameClick() {
        let currentTime = this.controller.player.currentTime();
        let dur = this.$refs.videoPlayerRef.getPlayerLiveDuration();//this.controller.player.duration();
        let isLive = dur === Infinity;
        
        // Validate position for live streams
        if (isLive) {
            let seekable = this.controller.player.seekable();
            if (seekable.length > 0) {
                let seekableStart = seekable.start(0);
                let seekableEnd = seekable.end(0);
                
                // Ensure current position is within seekable range
                if (currentTime < seekableStart || currentTime > seekableEnd) {
                    this.$toast.warning(this.$t('Cannot capture frame - position is outside the available range'));
                    return;
                }
            } else {
                this.$toast.warning(this.$t('Unable to capture frame from live stream'));
                return;
            }
        }
        
        this.markinMakoutValues.mark_in = null;
        this.markinMakoutValues.mark_out = null;
        this.annotatedImage = null;
        this.isCommentWithFrameVisible = true;
        this.isCommentTextboxVisible = this.isCommentWithFrameVisible;
        this.isOnlyCommentButtonActive = false;
        this.isCommentWithSegmentMarkinMarkout = false;
        this.controller.player.pause();
        this.resetMarkinMarkout();
        this.removeMarkersElement();
        this.removeAnnotationThumbnailDisplay();
        this.isPlaying = false;
        this.$el.querySelector('.send-review-messages').classList.remove('disable-text-editor');
        
        // Use the captured time value
        this.markinMakoutValues.mark_in = currentTime;
        
        // For live streams, ensure video is fully paused before capturing
        if (isLive) {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.captureVideoCanvas(() => {
                        try {
                            this.putTheAnnotationImageIntoComment();
                        } catch (e) {
                            console.log(e);
                        }
                    }, false);
                }, 100); // Small delay to ensure frame is stable
            });
        } else {
            this.captureVideoCanvas(() => {
                try {
                    this.putTheAnnotationImageIntoComment();
                } catch (e) {
                    console.log(e);
                }
            }, false);
        }
    },
    
   handleCommentWithSegmentClick() {
    let currentTime = this.controller.player.currentTime();
    let dur = this.$refs.videoPlayerRef.getPlayerLiveDuration();//this.controller.player.duration();
    let isLive = dur === Infinity;
    
    // Validate position for live streams
    if (isLive) {
        let seekable = this.controller.player.seekable();
        if (seekable.length > 0) {
            let seekableStart = seekable.start(0);
            let seekableEnd = seekable.end(0);
            
            // Ensure current position is within seekable range
            if (currentTime < seekableStart || currentTime > seekableEnd) {
                this.$toast.warning(this.$t('Cannot create segment - position is outside the available range'));
                return;
            }
            
            // Check if there's enough buffer for a segment
            let remainingBuffer = seekableEnd - currentTime;
            if (remainingBuffer < 1) { // Less than 1 second remaining
                this.$toast.warning(this.$t('Not enough buffer remaining for segment'));
                return;
            }
        } else {
            this.$toast.warning(this.$t('Unable to create segment for live stream'));
            return;
        }
    }
    
    this.markinMakoutValues.mark_in = null;
    this.markinMakoutValues.mark_out = null;
    this.annotatedImage = null;
    this.isCommentWithSegmentMarkinMarkout = true;
    this.isCommentTextboxVisible = this.isCommentWithSegmentMarkinMarkout;
    this.isOnlyCommentButtonActive = false;
    this.isCommentWithFrameVisible = false;
    this.resetMarkinMarkout();
    this.removeMarkersElement();
    this.removeAnnotationThumbnailDisplay();
    this.$el.querySelector('.send-review-messages').classList.remove('disable-text-editor');
    
      // Set mark_in with captured time before calling captureMarkin
      this.markinMakoutValues.mark_in = currentTime;
      
      this.$nextTick(() => {
          this.captureMarkin();
          this.$refs.markoutDurationRef.focus();
      });
      
      // For live streams, add delay before capturing canvas
      if (isLive) {
          this.$nextTick(() => {
              setTimeout(() => {
                  this.captureVideoCanvas(() => {
                      try {
                          this.putTheAnnotationImageIntoComment(false);
                      } catch (e) {
                          console.log(e);
                      }
                  }, false);
              }, 100);
          });
      } else {
          this.captureVideoCanvas(() => {
              try {
                  this.putTheAnnotationImageIntoComment(false);
              } catch (e) {
                  console.log(e);
              }
          }, false);
        }
     },
      
      closeMinimisedPlayer(){
        this.openPip = false;
        this.isImagePreviewDialogOpened = false
      },
      openPictureInPicture(fileInfo){
           console.log("[openPictureInPicture]",fileInfo);
           if(fileInfo.markers){
                    let markin = fileInfo.markers.start / 1000;
                    let markout = fileInfo.markers.end / 1000;
                    if(markin && isNaN(Number(markin))) markin = Utils.hhmmssToMs(markin);
                    if(markout && isNaN(Number(markout))) markout = Utils.hhmmssToMs(markout);
                    this.assetDetailsToShowPip = fileInfo;
                    Object.assign(this.assetDetailsToShowPip,{file_name:this.assetDetails.file_name,slug_name:this.assetDetails.slug_name,mime_type:'image/png'});
                    if(this.isFullscreenPreviewAllowed()){
                        this.openPip = false;
                        this.isImagePreviewDialogOpened = true;
                        return;
                    }else{
                        this.openPip = true;
                        this.isImagePreviewDialogOpened = false;
                    }
                    try{
                        setTimeout(() => {
                            this.$refs["miniPlayerReForSubclip"].playSubClipPreview({"markin":markin,"markout":markout});
                        },900);
                    }catch(e){console.log(e)}
            }else{
                this.assetDetailsToShowPip = fileInfo;
                if(this.isFullscreenPreviewAllowed()){
                    this.openPip = false;
                    this.isImagePreviewDialogOpened = true;
                    return;
                }else{
                    this.openPip = true;
                    this.isImagePreviewDialogOpened = false;
                }
            }
      },
      isFullscreenPreviewAllowed(){
        let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
        return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.assetDetailsToShowPip)) > -1
      },
      openPipOfAttachment(fileInfo){
        this.openPictureInPicture(fileInfo)
      },

      //-----------------MISCELLANEOUS------------------------------------
      isEnabled(priv) {
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
      },
      urlifyFromUtils(text){
        if(text != undefined && text != null && text != ""){
          var mentionsRegex = /\B@[a-z0-9_-]+/gi;
          let that = this;
          text = text.replace(mentionsRegex,function(mention){
              let temp = mention.substr(1);
              if(temp == that.getLoggedInUser){
                  return '<span style="border-radius: 15px;padding: 3px 7px;background: #007373c9;color: #eee;">' + mention + '</span>';
              }else{
                  return '<span style="border-radius: 15px;background: transparent;color: #2cbdbd;">' + mention + '</span>';
              }
          })
          var urlRegex = /(https?:\/\/[^\s]+)/g;
          return text.replace(urlRegex, function(url) {
              return '<a href="' + url + '" target="_blank" style="overflow-wrap: anywhere;color:#1d9bd1">' + url + '</a>';
          });
        }    
      },
      replaceByDefaultImage(e){
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
      },
      //---------------------------Comment---------------------------------
      unselectSelectedRow(){
        this.selectedCommentId = null;
      },
      cancelEditField(){
        this.isEditCommentID = null;
      },
      assignCommentIdToSelectedRow(commentInfo){
        this.selectedCommentId = commentInfo._id 
      },
      editParentComment(commentInfo){
        this.selectedCommentId = commentInfo._id;
        this.isEditCommentID = commentInfo._id;
      },
      updateOnlyCommentStatus(commentsDetails){
        this.editCommentText(null,commentsDetails)
      },
      editCommentText(message,commentInfo){
        let payload={};
        let commentObj = {};
        commentObj["status"] = commentInfo.status;
        commentObj["pid"] = commentInfo.pid;
        commentObj["_id"] = commentInfo._id;
        commentObj["edited"] = true;
        // commentObj["user_id"] = this.getLoggedInUserId;
        if(message){
          commentObj["comment"] = message;
        }else{
          commentObj["comment"] = commentInfo.comment;
        }
        payload.params = commentObj;
        payload['comment_id'] = commentInfo._id;
        this.updateGrowingMediaComments(payload).then((data) => {
            console.log("[updateGrowingMediaComments]",data);
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
                this.isEditCommentID = null;
                if(data.modified_data && 'comment' in data.modified_data && 'edited' in data.modified_data && data.modified_data.edited){
                    let f = this.reviewInfo.comments.find((e)=> e._id == commentInfo._id);
                    if(f){
                        Object.assign(f,data.modified_data);
                    }
                }
            }else{
                this.$toast.error(this.$t("Failed to edit comment"));
            }
        });
      },
      addCommentToReview(commentText,attachments){
        if(this.isOnlyCommentButtonActive){
            if(!commentText){
                alert(this.$t("Empty comment."));
                this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea').focus();
                return;
            }
        }

        if(this.isCommentWithSegmentMarkinMarkout && (this.markinMakoutValues.mark_in > -1 && this.markinMakoutValues.mark_out > -1) && (this.markinMakoutValues.mark_in == this.markinMakoutValues.mark_out)){
            alert(this.$t("Markin & Markout values are same. Please change Markout value."));
            return;
        }

        if(this.isCommentWithSegmentMarkinMarkout && !(this.isMarkoutValueAdded && this.markinMakoutValues.mark_out)){
            //show markout is not added error message
            this.isTourRequired = true;
            this.$refs.primaryCommentTextFromTextarea.commentText = commentText; // don't clear comment text
            this.$nextTick(()=>{
                setTimeout(()=>{
                    this.$tours['createReviewUserTour'].start();
                    this.$refs.primaryCommentTextFromTextarea.commentText = commentText; // don't clear comment text
                },600);
            });
            return;
         }

        if(this.isCommentWithSegmentMarkinMarkout || this.isCommentWithFrameVisible){
           if(!commentText){
                if(!confirm("Comment is empty. Are you sure you want to post?")){
                  this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea').focus();
                  return;
                }
            }
        }

        if(this.isCommentWithSegmentMarkinMarkout &&  this.markinMakoutValues.mark_in != null && this.markinMakoutValues.mark_out != null 
            && this.markinMakoutValues.mark_in > this.markinMakoutValues.mark_out
        ){
           alert(this.$t("Markin value greater than Markout. Please change Markout."));
           return;
        }

        let promiseDeferreds = {'isImageCaptured': null};
        let imageCapturedPromise = new Promise(function(resolve, reject){
            promiseDeferreds.isImageCaptured = {resolve: resolve, reject: reject};
        });
        let payload = {};
        if(this.isAnnotationEditorVisible && !this.annotatedImage && !this.isImageAnnotation){
           this.captureVideoCanvas(function(res){
              promiseDeferreds.isImageCaptured.resolve(res);
           });
        }else{
           promiseDeferreds.isImageCaptured.resolve('captured');
        }

        imageCapturedPromise.then(() => {
            console.log("this.reviewInfothis.reviewInfo",this.reviewInfo)
            payload = {
             "asset_id":this.assetDetails._id,
            'attachments':attachments,
            "comment": commentText,
            "edited":false,
            "comment_type":"Asset Comment",
            "pid": "0",
            // "user_id": this.getLoggedInUserId,
            "status": "open",
            ...this.getAnnotationData(),
          }

          this.addGrowingMediaComment(payload).then((data) =>{
              console.log("[addGrowingMediaComment]",data);
              try{
                 if(this.reviewInfo && this.reviewInfo.comments && Utils.isAcceptedStatusCode(data.statusCode) && data.upserted_data){
                    if(this.isAllMinimumDataStructureKeysPresent(data.upserted_data)){
                        let f = this.reviewInfo.comments.find((e)=> e._id == data.upserted_data._id);
                        if(!f){
                            this.reviewInfo.comments.unshift(data.upserted_data._id);
                        }
                    }
                  }
              }catch(e){console.log(e)}
              this.isCommentTextboxVisible = false;
              this.isOnlyCommentButtonActive = false;
              this.isCommentWithFrameVisible = false;
              this.isImageOnlyFinalStep = false;
              this.isCommentWithSegmentMarkinMarkout = false;
              this.isImageAnnotationFullScreen = false;
              this.$toast.success(this.$t("New Comment Added."));
              this.activeIndex = "comments";
              this.resetMarkinMarkout();
              this.removeMarkersElement();
              this.reloadMarkers(true);
              this.annotatedImage = null;
              this.isAnnotatedImageVisible = false;
              this.removeAnnotationThumbnailDisplay();
              try{
                this.$refs.tuiImageEditor.invoke('clearObjects');
                //this.hideShowMainCommentSendButton('hide');
              }catch(e){console.log(e)}
              try{
                 this.$el.querySelector('.send-review-messages').classList.add('disable-text-editor');
              }catch(e){console.log(e)}
              [].forEach.call(this.$el.querySelectorAll('.comment-row-wrapper.scroll-highlight-class'),(el) => {
                  el.classList.remove('scroll-highlight-class');
              });
              this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea').blur();
          }).catch(e => {
            console.log('e:',e);
            this.removeAnnotationThumbnailDisplay();
          });

        });
      },

      addReplyCommentToReview(commentText,attachments){
        let payload = {};
        payload.params = {
          'attachments':attachments,
          "asset_id":this.assetDetails._id,
          "comment": commentText,
          "pid": this.selectedCommentId,
          // "user_id": this.getLoggedInUserId,
          "status": "open",
          ...this.getAnnotationData(),
          // "markers":{
          //   "mark_in":1,
          //   "mark_out":3,
          //   "frame_thumbnail_uri":"share://proxy/2021/December/2021-12-30/Boat-30-12-3_110122_114014.png"
          // }
        }
        this.addGrowingMediaComment(payload.params).then((data) =>{
          this.$toast.success(this.$t("Added Reply"));
            console.log("checking posted reply", data);
          this.removeSelectedAnnotationPreview();
        });
      },

      showRepliesOfComment(selectedCommentInfo,isRepliesAvailable){
        this.selectedCommentId = selectedCommentInfo._id;
        if(isRepliesAvailable){
          this.getGrowingMediaComments(selectedCommentInfo._id).then((data) =>{
            this.repliedCommentslist = data["comments"];
          });
        }else{
          this.repliedCommentslist = [];
        }
      },

      deleteSelectedComment(commentsDetails){
        console.log("[deleteSelectedComment]",commentsDetails);
        if(commentsDetails.created_by_id == this.getLoggedInUserId){
          if (confirm(`Are you sure you want to delete the Comment ?`)) {
            let payload={};
            let selectedCommentId = commentsDetails._id;
            payload['comment_id'] = selectedCommentId;
            let commentObj = {};
            commentObj["status"] = "deleted";
            payload.params = commentObj;
            this.updateGrowingMediaComments(payload).then((data) => {
                if (Constants.acceptedStatusCodes.includes(data.status_code) || Constants.acceptedStatusCodes.includes(data.statusCode)) {
                    this.$toast.success(this.$t("Comment Deleted"));
                } else {
                    this.$toast.error(data.message);
                }
                if(data && data.modified_data && 'status' in data.modified_data && data.modified_data.status == 'deleted' 
                   && 'modified_datetime' in data.modified_data){
                      let f = this.reviewInfo.comments.find((e)=> e._id == commentsDetails._id);
                      console.log("[updateGrowingMediaComments][delete]",data,"Found:",f);
                      if(f){
                          Object.assign(f,data.modified_data);
                          if(String(data.modified_data.status).toLocaleLowerCase() == 'deleted'){
                              this.removeMarkerOnTimeLine(f);
                          }
                      }
                }
            });     
          }   
        }else{
          this.$toast.error(this.$t("Not allowed to delete Comment created by others."));
          return false;
        }
      },

      openFilePreview(fileObj){
          this.imagePreviewFileObj = fileObj;
          this.$nextTick(() => {
              this.isImagePreviewDialogOpened =  true;
          });
      },

      closeOpenedMentionsDopdown(){
        this.closeMentions = false;
        this.closeMentions = true;
      },

      getUsersListToMention(){
         return []; // not required for growing media
      },
      relocateElementBySelector(elementSelector, destSelector) {
          let element = parent.document.querySelector(elementSelector);
          let elementParent = element.parentElement;
          let destElement = parent.document.querySelector(destSelector);
          elementParent.removeChild(element);
          destElement.appendChild(element);
      },
      removeAnnotationThumbnailDisplay(){
         try{
            this.$refs.primaryCommentTextFromTextarea.$el.querySelector('.textarea-wrapper-for-annotation').classList.remove('make-way-for-thumbnail');
         }catch(e){console.log(e)}
         try{
           if(parent.document.getElementById('textarea-dynamic-image'))parent.document.getElementById('textarea-dynamic-image').remove();
         }catch(e){
           console.log(e);
         }
         this.annotatedImage = null;
      },

      cancelAnnotation(isFocusTextAreaRequired = true){
         this.isImageAnnotationFullScreen = false;
         this.hideShowMainCommentSendButton('show');
         if(!this.isImageAnnotation)
           this.isAnnotationEditorVisible = false;
         this.$nextTick(() =>{
          if(!this.isImageAnnotation)
            this.isEditorToolsWrapperVisible = false;
            this.removeAnnotationThumbnailDisplay();
         });
         this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea.text-area-with-border').value = '';
         if(parent.document.getElementById('apply_cancel_annotation_panel'))parent.document.getElementById('apply_cancel_annotation_panel').remove();
           
          /*
          this.isCommentTextboxVisible = false;
          this.isOnlyCommentButtonActive = false;
          this.isCommentWithFrameVisible = false;
          this.isCommentWithSegmentMarkinMarkout = false;
          this.$el.querySelector('.send-review-messages').classList.add('disable-text-editor');
          */
         if(!this.isImageAnnotation && isFocusTextAreaRequired){
            this.$nextTick(()=>{
                this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea').focus();
            });
         }
         if(this.isImageAnnotation && isFocusTextAreaRequired){
            if(this.$refs.primaryCommentTextFromTextarea && String(this.$refs.primaryCommentTextFromTextarea.commentText).length > 1){
                this.$nextTick(()=>{
                    this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea').focus();
                });
            }
         }
      },

      relocateToolsBars(){
         this.isEditorToolsWrapperVisible = true;
         let partitionLi = document.createElement('li');
         partitionLi.classList.add('tui-image-editor-item');
         partitionLi.classList.add('custom-added');
         partitionLi.innerHTML = `<div class="tui-image-editor-icpartition"></div>`;
         parent.document.querySelector('.tui-image-editor-menu').appendChild(partitionLi);

         this.relocateElementBySelector('.tie-btn-delete.tui-image-editor-item.help','.tui-image-editor-menu');
         this.relocateElementBySelector('.tie-btn-redo.tui-image-editor-item.help','.tui-image-editor-menu');
         this.relocateElementBySelector('.tie-btn-undo.tui-image-editor-item.help','.tui-image-editor-menu')


        let buttonElement = document.createElement('div'); 
        // buttonElement.classList.add('tui-image-editor-item');
        buttonElement.classList.add('custom-actions-button-wrapper');

        let ulElement = document.createElement('div');
        ulElement.classList.add('custom-annotation-button-wrapper');


       // if(!this.isImageAnnotation){
            let applyButtonLi = document.createElement('div');
            applyButtonLi.innerHTML = `<button type="button" title="${this.$t('Cancel Annotation')} (c)" class="btn btn-outline-secondary annotation-cancel-btn">${this.$t('Cancel')}</button>`;
            applyButtonLi.onclick = () => {
              this.cancelAnnotation();
            };
            ulElement.appendChild(applyButtonLi);
        //}

        let cancelButtonLi = document.createElement('div');
        cancelButtonLi.innerHTML = `<button type="button" title="${this.$t("Apply Annotation")} (s)" style="padding: 4px 35px !important;" class="btn btn-primary apply-annotation-btn">${this.$t('Apply')}</button>`;
        cancelButtonLi.onclick = () => {
          this.applyAnnotation();
        };

        ulElement.appendChild(cancelButtonLi);
        buttonElement.appendChild(ulElement);


        let applyCancelPanelEl = parent.document.getElementById('apply_cancel_annotation_panel');
        if(applyCancelPanelEl) applyCancelPanelEl.remove();

        if(this.isAnnotationEditorVisible){
          let applyCancelActionPanel = document.createElement('div');
          applyCancelActionPanel.id = 'apply_cancel_annotation_panel';
          parent.document.querySelector('.fusion-tui-image-editor-main-wrapper').insertAdjacentElement('afterend', applyCancelActionPanel);
          parent.document.querySelector('#apply_cancel_annotation_panel').appendChild(buttonElement);
        }
      },

      captureVideoCanvas(callback , isEditorRequiredToShow = true){
         this.isTourRequired = false;
          try{
              if(parent.document.getElementById('annotated-image-preview'))parent.document.getElementById('annotated-image-preview').remove();
          }catch(e){
            console.log('error',e);
          }
          try{
            this.controller.player.pause();
          }catch(e){console.log(e)}
          /*
          if(this.isMarkoutValueAdded){
            this.controller.player.currentTime(this.markinMakoutValues.mark_in);
          }*/
          try{
            this.hideShowMainCommentSendButton('hide');
          }catch(e){console.log(e)}
          try{
            this.removeAnnotationThumbnailDisplay();
          }catch(e){console.log(e)}
          this.$nextTick(() => {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");
            var video = parent.document.querySelector('video#reviewVideoPlayer, #reviewVideoPlayer video');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
          
            let videoWrapperEl = parent.document.querySelector('.video_wrapper');
            this.options.cssMaxWidth = videoWrapperEl.clientWidth;
            this.options.cssMaxHeight = videoWrapperEl.clientHeight - 150;

            let image = new Image();
            image.onload = () =>{
                let canvas2_ = document.createElement('canvas');
                canvas2_.crossOrigin = 'anonymous';
                let wrh =  image.width / image.height;
                let newWidth = video.clientWidth;
                let newHeight = newWidth / wrh;
                if (newHeight > video.clientHeight) {
                    newHeight = video.clientHeight;
                    newWidth = newHeight * wrh;
                    newHeight = newHeight - 25;
                }
                console.log('newWidth:',newWidth,'newHeight:',newHeight);

                canvas2_.style.height = newHeight+"px";
                canvas2_.width = newWidth;
                canvas2_.height = newHeight;

                canvas2_.getContext("2d").drawImage(image, 0, 0, newWidth , newHeight);
                let url = canvas2_.toDataURL('image/jpg');
                this.options.includeUI.loadImage.path = url;
                this.$nextTick(() => {
                    if(isEditorRequiredToShow){
                        this.isAnnotationEditorVisible = true;
                        this.isAnnotationCaptured = true;
                    }else{
                        this.annotatedImage = url;
                        this.hideShowMainCommentSendButton('show');
                        if(callback && typeof callback === 'function'){
                          return callback(url);
                        }
                        return;
                    }
                    if(callback && typeof callback === 'function'){
                        setTimeout(() => {
                          this.annotatedImage =  this.$refs.tuiImageEditor.invoke('toDataURL');
                          callback('captured');
                        },100);
                    }
                });
            }

            ctx.drawImage(video, 0, 0);
            let url = canvas.toDataURL('image/png');
            image.src = url;
          });
       },

       removeMarkersElement(){
          [].forEach.call(parent.document.querySelectorAll('.vjs-progress-control .common-markin-markout-icon'),(el)=>{
              el.remove();
          });

          [].forEach.call(parent.document.querySelectorAll('.vjs-progress-control .timeline-marker'),(el)=>{
              el.remove();
          })
       },

      removeMarkinElement(){
          [].forEach.call(parent.document.querySelectorAll('.vjs-progress-control .common-markin-markout-icon.in'),(el)=>{
              el.remove();
          });
       },

      removeMarkoutElement(){
          [].forEach.call(parent.document.querySelectorAll('.vjs-progress-control .common-markin-markout-icon.out'),(el)=>{
              el.remove();
          });
       },

       removeMarkerLine(){
          [].forEach.call(parent.document.querySelectorAll('.vjs-progress-control .timeline-marker'),(el)=>{
              el.remove();
          })
       },

       removeSelectedAnnotationPreview(){
         [].forEach.call(parent.document.querySelectorAll('.timeline-user-avatar.image-border-highlight'),(el) => {
              el.classList.remove('image-border-highlight');
          });
          [].forEach.call(parent.document.querySelectorAll('.comment-row-wrapper.scroll-highlight-class'),(el) => {
              el.classList.remove('scroll-highlight-class');
          })
       },

       resetMarkinMarkout(){
          this.isMarkoutValueAdded = false;
          this.markinDurationValue = '00:00:00';
          this.markinMakoutValues.mark_in = null;
          this.markinMakoutValues.mark_out = null;
          this.markoutDurationValue = '';
          this.markoutPlaceholderValue = '00:00:00';
          this.$
          try{
            [].forEach.call(parent.document.querySelectorAll('.common-markin-markout-input.active-markin-markout-duration'),(el) => {
              el.classList.remove('active-markin-markout-duration');
            });
            [].forEach.call(this.$el.querySelectorAll('.common-markin-markout-input.active-markin-markout-duration'),(el) => {
              el.classList.remove('active-markin-markout-duration');
            });
          }catch(e){console.log(e)}
          try{
            [].forEach.call(parent.document.querySelectorAll('.common-markin-markout-input.invalid-duration-value'),(el) => {
              el.classList.remove('invalid-duration-value');
            });
            [].forEach.call(this.$el.querySelectorAll('.common-markin-markout-input.invalid-duration-value'),(el) => {
              el.classList.remove('invalid-duration-value');
            });
          }catch(e){console.log(e)}
       },

       showPreviewButtonOnBlur(){
          if((this.markinMakoutValues.mark_in && this.markinMakoutValues.mark_out)
           && (this.markinDurationValue && this.markoutDurationValue)){
               this.isMarkoutValueAdded = true;
          }
       },

      handleMarkinInputBlur(){
          if((this.markinMakoutValues.mark_in && this.markinMakoutValues.mark_out)
           && (this.markinDurationValue && this.markoutDurationValue) && (this.markinMakoutValues.mark_in <= this.markinMakoutValues.mark_out)){
               this.setMarkinMarkout(this.markinMakoutValues.mark_out,'out');
          }
       },

       determineInOutDuration(comment,isSettingMarkerRequired = false){
          try{
            [].forEach.call(parent.document.querySelectorAll('.common-markin-markout-input.active-markin-markout-duration'),(el) => {
              el.classList.remove('active-markin-markout-duration');
            });
          }catch(e){console.log(e)}
          try{
            [].forEach.call(parent.document.querySelectorAll('.common-markin-markout-input.invalid-duration-value'),(el) => {
              el.classList.remove('invalid-duration-value');
            });
          }catch(e){console.log(e)}
          this.markinMakoutValues.mark_out = null;
          this.markoutPlaceholderValue = '00:00:00';
          this.markoutDurationValue = '';
          this.markinDurationValue = '';
          this.markinMakoutValues.mark_in = null;
          try{
            this.removeMarkersElement();
          }catch(e){console.log(e)}
          if(comment && comment.markers && !comment.markers.mark_out && comment.markers.mark_in > -1){
              this.controller.player.pause();
              // this.isPlaying = false;
              this.markinDurationValue = Utils.getExactDuationInSeconds(comment.markers.mark_in,this.videoFrameRate,'.');
              if(this.$refs['markinDurationRef']){
                  this.$refs.markinDurationRef.classList.add('active-markin-markout-duration');
              }
              this.controller.player.currentTime(comment.markers.mark_in);
              this.$nextTick(() => {
                  setTimeout(() => {
                      this.isPlaying = false;
                  },0);
              });
          }
          if(comment && comment.markers && comment.markers.mark_out > -1 && comment.markers.mark_in > -1){
              this.$nextTick(() => {
                setTimeout(() => {
                  this.controller.player.pause();
                  this.$nextTick(() => {
                     setTimeout(() => {
                         this.isPlaying = false;
                     },0);
                  });
                  this.markinMakoutValues.mark_out = comment.markers.mark_out;
                  this.markoutPlaceholderValue = comment.markers.mark_out;
                  this.markoutDurationValue = Utils.getExactDuationInSeconds(comment.markers.mark_out,this.videoFrameRate,'.');
                  this.markinDurationValue = Utils.getExactDuationInSeconds(comment.markers.mark_in,this.videoFrameRate,'.');
                  if(this.$refs['markinDurationRef']){
                        this.$refs.markinDurationRef.classList.add('active-markin-markout-duration');
                   }
                  if(this.$refs['markoutDurationRef']){
                      this.$refs.markoutDurationRef.classList.add('active-markin-markout-duration');
                  }
                  this.markinMakoutValues.mark_in = comment.markers.mark_in;
                  if(isSettingMarkerRequired){
                    this.setMarkinMarkout(comment.markers.mark_in,'in');
                    this.setMarkinMarkout(comment.markers.mark_out,'out');
                  }
                  this.$nextTick(() => {
                      this.controller.player.currentTime(comment.markers.mark_in);
                      if(isSettingMarkerRequired){
                         this.isCommentMarkinMarkoutPreview = true;
                         this.controller.player.play();
                         this.isPlaying = true;
                         this.controller.player.requestAnimationFrame(this.videoFrameCallback);
                      }
                      // this.isMarkoutValueAdded = true;
                  });
                },0);
              });
          }
       },

      setMarkinMarkout(inOut, type) {
          let typeIconMap = {in: '|', out: '|'};
          
            if(type == 'out') {
                try {
                    [].forEach.call(parent.document.querySelectorAll(`#m${this.markinUniqueId}`), (el) => {
                        el.remove();
                    });
                } catch(e) {
                    console.log(e);
                }
            }
            
            // Get duration - handle both VOD and live streams
            let totalPlayerDuration;
            let isLive = this.controller.player.duration() === Infinity;
            console.log("=============== isLive",isLive);
            
            if(isLive) {
                // For live streams, use the seekable range
                let seekable = this.controller.player.seekable();
                if(seekable.length > 0) {
                    totalPlayerDuration = seekable.end(0) - seekable.start(0);
                    // Adjust inOut relative to the seekable start
                    inOut = inOut - seekable.start(0);
                } else {
                    console.warn('No seekable range available for live stream');
                    return;
                }
            } else {
                // For VOD, use normal duration
                totalPlayerDuration = this.$refs.videoPlayerRef.getPlayerLiveDuration();//this.controller.player.duration();
            }

            console.log("inOut inOut, totalPlayerDuration",inOut,totalPlayerDuration);
            
            if(inOut < 0 || inOut > totalPlayerDuration) {
                console.warn('Mark position outside valid range');
                return;
            }
            
            let progressBar = this.controller.player.controlBar.progressControl.children_[0].el_;
            let markinElement = document.createElement('div');
            markinElement.classList.add('common-markin-markout-icon');
            markinElement.classList.add(type);
            
            if(type == 'out' && this.markinUniqueId) {
                markinElement.id = `m${this.markinUniqueId}`;
            }
            
            markinElement.innerHTML = `<span class="in-out-icon ${type}">${typeIconMap[type]}</span>`;
            let left = (inOut / totalPlayerDuration * 100) + '%';
            markinElement.style.cssText += `inset-inline-start${left}`;
            progressBar.appendChild(markinElement);
            
            if(type == 'out') {
                let div = document.createElement('div');
                div.classList.add('timeline-marker');
                let addedMarkersEl = Array.from(parent.document.querySelectorAll('.common-markin-markout-icon'));
                let width = addedMarkersEl[1].getBoundingClientRect().left - addedMarkersEl[0].getBoundingClientRect().left;
                div.style.cssText = `width:${width}px;top: -2.1px;height: 8px;border-radius: 5px; background: #e91e63; position: absolute; inset-inline-start:calc(${addedMarkersEl[0].style.left} + 1.7px);`;
                progressBar.appendChild(div);
            }
        },

       showTimelineMarker(comment){
         //this.selectedCommentInfo = comment;
         if(comment && comment.status && String(comment.status).toLowerCase() == 'deleted') return;
          try{
            this.removeAnnotatedPreview();
          }catch(e){console.log(e)}
          [].forEach.call(parent.document.querySelectorAll('.timeline-user-avatar.image-border-highlight'),(el) => {
              el.classList.remove('image-border-highlight');
          });
          [].forEach.call(parent.document.querySelectorAll(`.vjs-progress-control .user-name-or-image.image-border-highlight`),(el) => {
            el.classList.remove('image-border-highlight');
          });
          [].forEach.call(parent.document.querySelectorAll('.comment-row-wrapper.scroll-highlight-class'),(el) => {
              el.classList.remove('scroll-highlight-class');
          });
          try{
             parent.document.querySelector(`.user-name-or-image[data-id="${comment._id}"] .timeline-user-avatar`).classList.add('image-border-highlight');
          }catch(e){
             console.log(e);
             if(parent.document.querySelector(`.user-name-or-image[data-id="${comment._id}"]`))
             parent.document.querySelector(`.user-name-or-image[data-id="${comment._id}"]`).classList.add('image-border-highlight');
          }
          parent.document.querySelector(`.comment-row-wrapper[data-id="${comment._id}"]`).classList.add('scroll-highlight-class');
          [].forEach.call(parent.document.querySelectorAll('.vjs-marker.active-timeline-marker-bullet'),(el) => {
             el.classList.remove('active-timeline-marker-bullet');
          });
          if(parent.document.querySelector(`.vjs-marker[data-id="${comment._id}"]`))parent.document.querySelector(`.vjs-marker[data-id="${comment._id}"]`).classList.add('active-timeline-marker-bullet');
          this.determineInOutDuration(comment,true);
       },

       removeUserAndMarkerFromTimeline(){
          try{
            this.removeAllMarkerOnTimeLine();
          }catch(e){console.log(e)}
          try{
              this.removeMarkersElement();
          }catch(e){console.log(e)}
       },

  setCommentsMarkers(markers = []) {
    this.removeUserAndMarkerFromTimeline();
    
    let totalPlayerDuration = this.$refs.videoPlayerRef.getPlayerLiveDuration();//this.controller.player.duration();
    let progressBar = this.controller.player.controlBar.progressControl.children_[0].el_;
    
    // Handle live streams
    let isLive = totalPlayerDuration === Infinity;
    let seekableStart = 0;
    let seekableDuration = totalPlayerDuration;
    
      if (isLive) {
          let seekable = this.controller.player.seekable();
          if (seekable.length > 0) {
              seekableStart = seekable.start(0);
              seekableDuration = seekable.end(0) - seekable.start(0);
          } else {
              console.warn('No seekable range available for live stream');
              return;
          }
      }
    
      for (let i = 0; i < markers.length; i++) {
          if (markers[i] && markers[i].comment && markers[i].comment.status && 
              String(markers[i].comment.status).toLowerCase() == 'deleted') continue;
          
            console.log('markers of i', markers[i]);
            
            let time = markers[i].time;
            
            // Calculate position based on stream type
            let left;
            if (isLive) {
                // For live streams, calculate position relative to seekable range
                let relativeTime = time - seekableStart;
                
                // Skip if marker is outside seekable range
                if (relativeTime < 0 || relativeTime > seekableDuration) continue;
                
                left = (relativeTime / seekableDuration * 100) + '%';
            } else {
                // For VOD, use standard calculation
                if (time > totalPlayerDuration) continue;
                left = (time / totalPlayerDuration * 100) + '%';
            }
            
            if (markers[i] && markers[i].comment && markers[i].comment.markers && 
                (markers[i].comment.markers.mark_in == null || markers[i].comment.markers.mark_in < 0)) continue;
            
            let markerDiv = document.createElement('div');
            markerDiv.classList.add('vjs-marker');
            markerDiv.style.cssText += `inset-inline-start:${left}`;
            markerDiv.setAttribute('data-time', time);
            markerDiv.setAttribute('data-id', markers[i].comment._id);
            
            try {
                if (this.$el.querySelector(`.vjs-marker[data-id="${markers[i].comment._id}"]`)) {
                    this.$el.querySelector(`.vjs-marker[data-id="${markers[i].comment._id}"]`).remove();
                }
            } catch (e) {
                console.log(e);
            }
            
            if (markers[i].user && markers[i].user.profile_image) {
                markerDiv.innerHTML = `
                    <div data-id="${markers[i].comment._id}" class="reviewer-name-intial-letter user-name-or-image"> 
                        <img src="${this.getProxyConvertedURL(markers[i].user.profile_image)}" class="timeline-user-avatar" style="width:100%;height:100%;border-radius:6px;"/>
                    </div>
                    <span style="visibility:hidden;position: absolute; width: 176px; height: 99px; bottom: 49px; border: 3px solid #fff; border-radius: 2px;" class="annotated-image-thumbnail">
                        <img style="width:100%;height:100%;" src="${this.getProxyConvertedURL(markers[i].comment.markers.frame_thumbnail_uri)}"/>
                    </span>
                `;
            } else {
                let res = '', styles = this.style(markers[i].user.username);
                for (let key in styles) {
                    res += `${key}:${styles[key]};`
                }
                markerDiv.innerHTML = `
                    <div class="user-name-or-image reviewer-name-intial-letter" data-id="${markers[i].comment._id}" title="${markers[i].user.username}" style="${res}">
                        <span>${markers[i].user.username.split("")[0]}</span>
                    </div>
                    <span style="visibility:hidden;position: absolute; width: 176px; height: 99px; bottom: 68px; border: 3px solid #fff; border-radius: 2px;" class="annotated-image-thumbnail">
                        <img class="timeline-user-avatar" style="width:100%;height:100%;" onerror="this.onerror=null;this.src='${this.getNoThumbnailImage()}'" src="${this.getProxyConvertedURL(markers[i].comment.markers.frame_thumbnail_uri)}"/>
                    </span>
                `;
            }
            
            markerDiv.onclick = () => {
                this.controller.player.currentTime(markerDiv.getAttribute('data-time'));
                this.showComments(markers[i].comment);
            };
            
            progressBar.appendChild(markerDiv);
        }
      },
       setController(controller){
            this.controller = controller;
            this.$nextTick(() => {
                if('file_info' in this.reviewInfo){
                  this.controller.restartPlayer(this.reviewInfo.file_info[0].proxy_info.lowres_uri);
                  this.playerListener();
                }
            });
       },

      getAnnotationData(){
          // let base64Image = this.$refs.tuiImageEditor.invoke('toDataURL');
            // let currentTime = this.controller.player.currentTime();
            let markin = null, markout = null;
            if(this.markinMakoutValues.mark_in != null && this.markinMakoutValues.mark_in > -1){
                markin = this.markinMakoutValues.mark_in;
            }
            if(this.isMarkoutValueAdded && this.markinMakoutValues.mark_out != null && this.markinMakoutValues.mark_out > -1){
                markout = this.markinMakoutValues.mark_out;
            }
            return {markers:{mark_in:markin,mark_out:markout,frame_thumbnail_uri:this.annotatedImage}};          
      },

      putTheAnnotationImageIntoComment(isTextAreaFocusRequired = true){
        this.$nextTick(() => {
             this.$refs.primaryCommentTextFromTextarea.$el.querySelector('.textarea-wrapper-for-annotation').classList.add('make-way-for-thumbnail');
             if(parent.document.getElementById('textarea-dynamic-image')) parent.document.getElementById('textarea-dynamic-image').remove();
             let img = new Image();
             img.src = this.annotatedImage;
             let style = document.createElement('style');
             style.id="textarea-dynamic-image";
             style.innerHTML = `.make-way-for-thumbnail::before{background-image:url(${img.src});color:red;}`
             parent.document.head.appendChild(style);
         });
         this.$nextTick(() => {
            this.isAnnotatedImageVisible =  true;
         });
        //  this.cancelAnnotation();
        if(isTextAreaFocusRequired){
           this.$nextTick(()=>{
                setTimeout(()=>{
                    this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea.text-area-with-border').focus();
                },500);
           });
        }
        if(!this.isImageAnnotation){
          this.isAnnotationEditorVisible = false;
          this.isEditorToolsWrapperVisible = false;
          try{
             parent.document.getElementById('apply_cancel_annotation_panel').remove();
          }catch(e){console.log(e)}
        }
        try{
           parent.document.getElementById('apply_cancel_annotation_panel').remove();
        }catch(e){console.log(e)}
        
      },

      applyAnnotation(){
         this.hideShowMainCommentSendButton('show');
         this.annotatedImage =  this.$refs.tuiImageEditor.invoke('toDataURL');
         this.putTheAnnotationImageIntoComment();

         this.$nextTick(()=>{
            this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea').focus();
         });

         if(this.isImageType){
            this.isImageOnlyFinalStep = true;
            this.$el.querySelector('.send-review-messages').classList.remove('disable-text-editor');
         }else{
            this.isImageOnlyFinalStep = false;
         }
        /*
        this.isCommentTextboxVisible = false;
        this.isOnlyCommentButtonActive = false;
        this.isCommentWithSegmentMarkinMarkout = false;

        if(this.isCommentWithSegmentMarkinMarkout){
            this.isCommentTextboxVisible = true;
        }
        
        if(this.isCommentWithFrameVisible){
           this.isCommentTextboxVisible = true;
        }
        */
       this.isImageAnnotationFullScreen = false;
       if(this.isImageAnnotation){
          this.isOnlyCommentButtonActive = true;
          this.$nextTick(()=>{
            setTimeout(()=>{
                 this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea.text-area-with-border').focus();
            },500);
          });
       }else{
          this.$nextTick(()=>{
            setTimeout(()=>{
                 this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea.text-area-with-border').focus();
            },500);
          });
       }
      },

      removeAnnotatedPreview(){
          if(parent.document.getElementById('annotated-image-preview')) parent.document.getElementById('annotated-image-preview').remove();
      },

      showAnnotatedImagePreview(comment){
        if(parent.document.getElementById('annotated-image-preview')) parent.document.getElementById('annotated-image-preview').remove();
        let style = document.createElement('style');
        style.id = 'annotated-image-preview';
        let imageUrl = comment.markers.frame_thumbnail_uri ? comment.markers.frame_thumbnail_uri : this.getNoThumbnailImage();
        style.innerHTML = `#reviewVideoPlayer::before{position: absolute; content: ""; inset-inline-start :0; top: 0; width: 100%; height: 93%; background-image: url("${imageUrl}"); background-size: contain; background-position: center; z-index: 99; background-color: #0d0d0d; cursor: default;}`;
        parent.document.head.appendChild(style);
      },

      showComments(comment){
          // console.log('show comment',comment,'this.$refs.mainCommentsWrapper',this.$refs.mainCommentsWrapper,'sssssss',parent.document.querySelector(`.comment-row-wrapper[data-id="${comment._id}"]`));
          [].forEach.call(parent.document.querySelectorAll(`.vjs-progress-control .user-name-or-image img.timeline-user-avatar`),(el) => {
             el.classList.remove('image-border-highlight');
          });
          [].forEach.call(parent.document.querySelectorAll(`.vjs-progress-control .user-name-or-image.image-border-highlight`),(el) => {
            el.classList.remove('image-border-highlight');
          });
          try{
             parent.document.querySelector(`.vjs-progress-control .user-name-or-image[data-id="${comment._id}"] img.timeline-user-avatar`).classList.add('image-border-highlight');
          }catch(e){
             console.log(e);
             parent.document.querySelector(`.vjs-progress-control .user-name-or-image[data-id="${comment._id}"]`).classList.add('image-border-highlight');
          }
          try{
              Utils.scrollToElement(parent.document.querySelector(`.comment-row-wrapper[data-id="${comment._id}"]`),this.$refs.mainCommentsWrapper);
          }catch(e){console.log(e)}
          [].forEach.call(parent.document.querySelectorAll('.comment-row-wrapper'),(el) => {
             el.classList.remove('scroll-highlight-class');
          });
          try{
            parent.document.querySelector(`.comment-row-wrapper[data-id="${comment._id}"]`).classList.add('scroll-highlight-class');
          }catch(e){console.log(e)}
          this.controller.player.pause();
          // this.isPlaying = false;
          this.showAnnotatedImagePreview(comment);
          [].forEach.call(parent.document.querySelectorAll('.vjs-marker.active-timeline-marker-bullet'),(el) => {
             el.classList.remove('active-timeline-marker-bullet');
          });
          parent.document.querySelector(`.vjs-marker[data-id="${comment._id}"]`).classList.add('active-timeline-marker-bullet');
          this.determineInOutDuration(comment);
      },

      reloadMarkers(isCancelRequired = false){
          try{
            [].map.call(this.$el.querySelectorAll('.vjs-progress-control .vjs-marker'),(e)=>{
                  e.remove();
            })
          }catch(e){console.log(e)}
          this.$nextTick(() => {
              //this.setCommentsMarkers(this.getMarkersList(this.reviewInfo['comments']));
              if(isCancelRequired) this.cancelAnnotation(false);
          });
      },

      captureMarkin() {
          let currentTime = this.controller.player.currentTime();
          let dur = this.$refs.videoPlayerRef.getPlayerLiveDuration();//this.controller.player.duration();
          let isLive = dur === Infinity;

          console.log("dur dur isLive isLive [currentTime]",dur, isLive, currentTime)
          
          // Validate markin position for live streams
          if (isLive) {
              let seekable = this.controller.player.seekable();
              if (seekable.length > 0) {
                  let seekableStart = seekable.start(0);
                  let seekableEnd = seekable.end(0);
                  
                  // Ensure markin is within seekable range
                  if (currentTime < seekableStart || currentTime > seekableEnd) {
                      this.$toast.warning(this.$t('Markin position is outside the available range'));
                      return;
                  }
              } else {
                  this.$toast.warning(this.$t('Unable to set markin for live stream'));
                  return;
              }
          }
          
          this.clearMarkinMarkout();
          
          this.$nextTick(() => {
              this.markinMakoutValues.mark_in = currentTime;
              this.markinDurationValue = Utils.getExactDuationInSeconds(currentTime, this.videoFrameRate, '.');
              this.markoutDurationValue = '';
              this.isMarkinButtonClicked = true;
              this.markinUniqueId = Utils.getUUID();
              this.setMarkinMarkout(currentTime, 'in');
              this.$refs.markinDurationRef.classList.add('active-markin-markout-duration');
          });
      },

      captureMarkout() {
          if (!this.markinDurationValue) { 
              this.$toast.warning(this.$t('Please add Markin first')); 
              return; 
          }
          
          this.controller.player.pause();
          
          let currentTime = this.controller.player.currentTime();
          let dur = this.$refs.videoPlayerRef.getPlayerLiveDuration();//this.controller.player.duration();
          let isLive = dur === Infinity;
          
          // Validate markout position for live streams
          if (isLive) {
              let seekable = this.controller.player.seekable();
              if (seekable.length > 0) {
                  let seekableStart = seekable.start(0);
                  let seekableEnd = seekable.end(0);
                  
                  // Ensure markout is within seekable range
                  if (currentTime < seekableStart || currentTime > seekableEnd) {
                      this.$toast.warning(this.$t('Markout position is outside the available range'));
                      return;
                  }
                  
                  // Ensure markout is after markin
                  if (this.markinMakoutValues.mark_in && currentTime <= this.markinMakoutValues.mark_in) {
                      this.$toast.warning(this.$t('Markout must be after Markin'));
                      return;
                  }
              } else {
                  this.$toast.warning(this.$t('Unable to set markout for live stream'));
                  return;
              }
          } else {
              // For VOD, ensure markout is after markin
              if (this.markinMakoutValues.mark_in && currentTime <= this.markinMakoutValues.mark_in) {
                  this.$toast.warning(this.$t('Markout must be after Markin'));
                  return;
              }
          }
          
          this.markinMakoutValues.mark_out = currentTime;
          this.isMarkinButtonClicked = false;
          this.markoutPlaceholderValue = Utils.getExactDuationInSeconds(currentTime, this.videoFrameRate, '.');
          this.markoutDurationValue = this.markoutPlaceholderValue;
          
          this.$nextTick(() => {
              this.isMarkoutValueAdded = true;
          });
          
          this.setMarkinMarkout(currentTime, 'out');
          this.$refs.markoutDurationRef.classList.add('active-markin-markout-duration');
          
          this.$nextTick(() => {
              this.$refs.primaryCommentTextFromTextarea.$el.querySelector('textarea').focus();
          });
      },

      resetDurationColor(){
         try{
            [].forEach.call(parent.document.querySelectorAll('.common-markin-markout-input.active-markin-markout-duration'),(el) => {
              el.classList.remove('active-markin-markout-duration');
            });
         }catch(e){console.log(e)}
      },

      clearMarkinMarkout(){
          this.markinMakoutValues.mark_in = null;
          this.markinMakoutValues.mark_out = null;
          this.$nextTick(() => {
            this.isMarkoutValueAdded = false;
         });
         this.markinDurationValue = '';
         this.markoutDurationValue = '';
         this.markoutPlaceholderValue = '00:00:00';
         this.removeMarkersElement();
         this.resetDurationColor();
         this.$refs.markoutDurationRef.classList.remove('active-markin-markout-duration');
         this.$refs.markinDurationRef.classList.remove('active-markin-markout-duration');
         this.removeAnnotationThumbnailDisplay();
      },

     playMarkinMarkoutPreview(){
        this.isActivePreview = true;

        if(this.controller.player.paused())
             this.controller.player.currentTime(this.markinMakoutValues.mark_in);

        if(this.controller.player.paused())
            this.controller.player.play();

        this.controller.player.requestAnimationFrame(this.videoFrameCallback);

     },

     isValidDuration(event){
       console.log('event',event.target.value);
       try{
         this.removeAnnotatedPreview();
       }catch(e){console.log(e)}
       let isValid = Utils.isValidDuration(event.target.value,this.$refs.videoPlayerRef.getPlayerLiveDuration(),this.videoFrameRate);
       let durationInRange = Utils.hhmmssffToMs(event.target.value,this.$refs.videoPlayerRef.getPlayerLiveDuration(),this.videoFrameRate);
       if(isValid && durationInRange <= this.$refs.videoPlayerRef.getPlayerLiveDuration()){
           event.target.classList.remove('invalid-duration-value');
           event.target.classList.add('active-markin-markout-duration');
           if(event.target.getAttribute('data-type') == 'markin'){
                this.removeMarkinElement();
                console.log(`duration :::`,durationInRange);
                setTimeout(() => {
                  this.markinDurationValue = event.target.value;
                  this.markinMakoutValues.mark_in = durationInRange;
                  this.setMarkinMarkout(durationInRange,'in');
                },0);
           }
           if(event.target.getAttribute('data-type') == 'markout' && this.$refs.markinDurationRef.value){
                this.removeMarkoutElement();
                this.removeMarkerLine();
                this.markoutDurationValue = event.target.value;
                this.markinMakoutValues.mark_out = durationInRange;
                if(this.markinMakoutValues.mark_in > this.markinMakoutValues.mark_out){
                    this.$refs.markinDurationRef.classList.remove('active-markin-markout-duration');
                    this.$refs.markinDurationRef.classList.add('invalid-duration-value');
                }else{
                  this.$refs.markinDurationRef.classList.remove('invalid-duration-value');
                  this.$refs.markinDurationRef.classList.add('active-markin-markout-duration');
                  setTimeout(() => {
                    this.markoutDurationValue = event.target.value;
                    this.markinMakoutValues.mark_out = durationInRange;
                    this.setMarkinMarkout(durationInRange,'out');
                  },0);
                }
           }
       }else{
          event.target.classList.remove('active-markin-markout-duration');
          event.target.classList.add('invalid-duration-value');
       }
     },

     removeMarkerOnTimeLine(commentInfo){
       if(commentInfo && commentInfo._id && parent.document.querySelector(`.vjs-marker[data-id="${commentInfo._id}"]`)){
           try{
             this.$el.querySelector(`.vjs-marker[data-id="${commentInfo._id}"]`).remove();
           }catch(e){console.log(e)}
           parent.document.querySelector(`.vjs-marker[data-id="${commentInfo._id}"]`).remove();
       }
     },

     removeAllMarkerOnTimeLine(){
           try{
             this.$el.querySelector(`.vjs-marker`).remove();
           }catch(e){console.log(e)}
     },

     hideShowMainCommentSendButton(type){
       try{
        this.$refs.primaryCommentTextFromTextarea.$el.querySelector('button.main-comment-btn').classList.remove('show');
        this.$refs.primaryCommentTextFromTextarea.$el.querySelector('button.main-comment-btn').classList.remove('hide');
        this.$refs.primaryCommentTextFromTextarea.$el.querySelector('button.main-comment-btn').classList.add(type);
       }catch(e){console.log(e)}
     },

     /**
      *   common code below
      */
     style(name){
      let style = {
        'color':this.textColor(this.intToRGB(this.hashCode(name))),
        'background-color':'#'+this.intToRGB(this.hashCode(name))
      }
      return style
    },
    hashCode(str) { // java String#hashCode
        var hash = 0;
        if(str && str.length){
          for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
          }
        }  
        return hash;
    },
    intToRGB(i){
        var c = (i & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();

        return "00000".substring(0, 6 - c.length) + c;
    },
    textColor(hexcolor){
      // If a leading # is provided, remove it
      if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1);
      }

      // Convert to RGB value
      var r = parseInt(hexcolor.substr(0,2),16);
      var g = parseInt(hexcolor.substr(2,2),16);
      var b = parseInt(hexcolor.substr(4,2),16);

      // Get YIQ ratio
      var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

      // Check contrast
      return (yiq >= 128) ? 'black' : 'white';

    },
    getNoThumbnailImage(){
      return Utils.getNoThumbnailImg();
    },
    replaceWithUserIcon(e){
        console.log('called me......',e);
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
    },
    getProfileImageOfUser(image){
      let defaultImage = Utils.getNoThumbnailImg();
      let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; this.onerror = null"  style="width:100%;height:100%;border-radius:6px">'
      return profileImageTag;
    },
    closeModal(){
        try{
          if(parent.document.getElementById('annotated-image-preview'))parent.document.getElementById('annotated-image-preview').remove();
        }catch(e){console.log(e)}
        if (Object.keys(this.parentRouteInfo).length !=0 && Object.keys(this.parentRouteInfo).includes("name") ){
            this.$router.push({
              name: this.parentRouteInfo.name,
              params:this.parentRouteInfo.params,
              query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
            })
        }else{
            this.$router.push({
               name: "explorer",
            })
        }
      },

      togglePlayPause(){
        this.removeAnnotatedPreview();
        if(this.controller.player.paused()){
            this.controller.player.play();
            this.isPlaying = true;
        }else{
            this.controller.player.pause();
            this.isPlaying = false;
        }
      },

      playerListener(){
        this.controller.player.on("pause", ()=>{
            this.isPlaying = false
        });

        this.controller.player.on("play",  ()=> {
            this.isPlaying = true
        });

        this.controller.player.controlBar.progressControl.on('mousedown', () =>{
           console.log('mouse down here ..........');
           this.removeAnnotatedPreview();
        });
      },

      videoFrameCallback(){
          console.log('[videoFrameCallback] videoFrameCallback........');
          if(this.isMarkinButtonClicked){
                this.markoutPlaceholderValue = Utils.getDurationInSeconds(this.controller.player.currentTime());
            }
            
          if(this.controller.player.currentTime() >=  this.markinMakoutValues.mark_out){
            if(this.isMarkoutValueAdded && this.controller.player.currentTime() >=  this.markinMakoutValues.mark_out){
              this.controller.player.pause();
              this.isActivePreview = false;
            }

            if(this.isCommentMarkinMarkoutPreview && this.controller.player.currentTime() >=  this.markinMakoutValues.mark_out){
                this.controller.player.pause();
                this.$nextTick(() => {
                    this.isCommentMarkinMarkoutPreview = false;
                });
            }
          }else{
              this.controller.player.requestAnimationFrame(this.videoFrameCallback);
          }
      },

      getMarkersList(comment){
         let markers = [], commentsList = [];
         if(comment && Object.keys(comment).length){ 
           commentsList = [comment]; 
          }else if(!comment){
             commentsList = this.reviewInfo.comments;
          }
          if(comment && Array.isArray(comment) && comment.length){
              commentsList = comment;
          }
          if(comment && Array.isArray(comment) && !comment.length){
              commentsList = comment;
          }
          for(let i = 0; i < commentsList.length; i++){
              let user = {username:null,profile_image:null};
              if(commentsList[i] && commentsList[i].username) user.username = commentsList[i].username;
              if(commentsList[i] && commentsList[i].profile_image && commentsList[i].user_id) user.profile_image = commentsList[i].profile_image[commentsList[i].user_id];
              // if(commentsList[i] && commentsList[i].markers && commentsList[i].markers.frame_thumbnail_uri && commentsList[i].markers.mark_in){
              if(commentsList[i] && commentsList[i].markers && commentsList[i].markers.mark_in != null && commentsList[i].markers.mark_in > -1){
                markers.push({
                  markin:commentsList[i].markers.mark_in,
                  markout:commentsList[i].markers.mark_out,
                  time:commentsList[i].markers.mark_in,
                  user:{...user},
                  comment:commentsList[i],
                });
              }
          }
         return markers;
      },

      videoPlayerMetadataLoaded(){
          try{
            this.removeUserAndMarkerFromTimeline();
          }catch(e){console.log(e)}
          try {
            this.clearMarkinMarkout();
          } catch (error) {console.log(error)}
        //  if(!this.isPlayerInitialized) return;
          this.isShowingLoadingDiv = false;
          this.isPlayerInitialized = true;
          this.playerListener();
         // this.setCommentsMarkers(this.getMarkersList(this.reviewInfo.comments));
      },

      handleKeyBoardShortcuts(event){
            let keyCode = event.keyCode || event.which;
            console.log(keyCode,event);
            // if(document.activeElement && document.activeElement.classList.contains('common-markinmarkout-action-btn')) return true;
            let pressedElement = String(event.target.nodeName).toLowerCase();
            if(pressedElement == 'input' || pressedElement == 'textarea' || pressedElement == 'select' || pressedElement == 'canvas' ) return true;
            console.log('execute keycode');

            try{
               if(this.$refs.primaryCommentTextFromTextarea.browserType == 'fusion'){
                   console.log('filebrowse is opened');
                   return true;
               }
            }catch(e){console.log(e)}
           
            if(keyCode === 32){ // 'spacebar' key for toggle play->pause
                this.togglePlayPause();
            } 

            /* Not required now
            if(keyCode === 97){ // 'a' key for annotation
                this.captureVideoCanvas();
             } 
            */

            if(keyCode == 99){ // 'c' key to cancel annotation
              if(this.isAnnotationEditorVisible){
                if(window.confirm(this.$t('Discard Annotation')+'?'))
                  this.cancelAnnotation();
              }
            }

            if(keyCode == 115){ // 's' key to apply annotation
               if(this.isAnnotationEditorVisible){
                 this.applyAnnotation();
               }
            }

            if(this.isCommentWithSegmentMarkinMarkout && keyCode == 105){ // 'i' key to markin
                this.captureMarkin();
            }

            if(this.isCommentWithSegmentMarkinMarkout && keyCode == 111){ // 'o' key to markout
                this.captureMarkout();
            }

            if(this.isCommentWithSegmentMarkinMarkout && keyCode == 112){ // 'p' key to Preview markin,markout region
                this.playMarkinMarkoutPreview();
            }

            /* Not required..
            if(this.isCommentWithSegmentMarkinMarkout && keyCode == 99){ // 'c' key to Clear markin,markout region
                this.clearMarkinMarkout();
            }
            */
      },

      addBorderColor(){
        return this.reviewInfo.status == 'Open'?'applyYellowColor':'ApplyRedColor'
      },

      selectionLabelCallback(option){
        return `V-${option.version_number}`
      },

    handleNewCommentCreated(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message && notification.message.comment_type == "Asset Comment"){
          if(this.reviewInfo && this.reviewInfo.comments){
             let f = this.reviewInfo.comments.find((e)=> e._id == notification.message._id);
             if(!f){
                this.reviewInfo.comments.unshift(notification.message);
               // this.setCommentsMarkers(this.getMarkersList(this.reviewInfo.comments));
             }
          }
      }
    },

    handleCommentModified(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message && notification.message.comment_type == "Asset Comment"){
           if(this.reviewInfo && this.reviewInfo.comments){
             let f = this.reviewInfo.comments.find((e)=> e._id == notification.message._id);
             if(f){
                Object.assign(f,notification.message);
                if(String(notification.message.status).toLocaleLowerCase() == 'deleted'){
                    this.removeMarkerOnTimeLine(notification.message);
                }
             }
          }
      }
    },

    registerforWebsocketNotifications(){
          this.addWSEventListener({eventname:["CommentCreated"],
            callback:this.handleNewCommentCreated,
            parent: "growingMediaComment"})

          this.addWSEventListener({eventname:["CommentModified"],
            callback:this.handleCommentModified,
            parent: "growingMediaComment"})
    },

    unRegisterforWebsocketNotifications(){
          this.removeWSEventListener({eventname:["CommentCreated"],
            callback:this.handleNewCommentCreated,
            parent: "growingMediaComment"})

          this.removeWSEventListener({eventname:["CommentModified"],
            callback:this.handleCommentModified,
            parent: "growingMediaComment"})

    },
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("assets",["getGrowingMediaComments","addGrowingMediaComment","updateGrowingMediaComments","getGrowingMediaComments"]),
   },
   computed:{
    isVideoType(){
      if(this.assetDetails){
         return Utils.getFileMediaType(this.assetDetails) == 'video';
      }
      return false;
    },
    isImageType(){
      if(this.assetDetails){
         return Utils.getFileMediaType(this.assetDetails) == 'image';
      }
      return false;
    },
    ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserPrivilege"]),
   },
   created(){
       let r = {};
       try{
        if(this.$route && this.$route.params && this.$route.params.parentinfo){
          let params = {};
          if(this.$route.params.parentinfo.params && typeof this.$route.params.parentinfo.params == 'string')
             params = JSON.parse(this.$route.params.parentinfo.params);
          let query = {};
          if(this.$route.params.parentinfo.query && typeof this.$route.params.parentinfo.query == 'string')
             query = JSON.parse(this.$route.params.parentinfo.query);
          r = {name:this.$route.params.parentinfo.name,query:{...query},params:{...params}};
        }
       }catch(e){console.log(e)}
        Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?r:{});
        try{
          this.registerforWebsocketNotifications();
        }catch(e){console.log(e)}

        if(this.fileInfo){
           this.assetDetails = this.fileInfo;
        }else{
            this.assetDetails = this.$route.params.fileInfo;
        }
        if(this.assetDetails && !Object.prototype.hasOwnProperty.call(this.assetDetails,'mime_type')){
          Object.assign(this.assetDetails,{mime_type:"video/mp4"});
        }
        let mediaType = Utils.getFileMediaType(this.assetDetails);
        this.getGrowingMediaComments({params:{"asset_id":this.assetDetails._id,comment_type:"Asset Comment"}}).then((data)=>{
            console.log("DATTTTAAAA",data);
            this.reviewInfo.comments = data.asset_comments;
            if(mediaType == 'video')
               this.isPlayerLoaded = true;

            for(let key in data){
                 if(Object.prototype.hasOwnProperty.call(this.paginationInfo,key)){
                     this.paginationInfo[key] = data[key];
                 }
            }
        });
  
        const setupVideoPlayer = () =>{
              this.videoOptions.sources.push({
                  src:Utils.getLowresPathfromFileInfo(this.assetDetails),
                  type: "video/mp4"
              });
        }
        if(mediaType == 'video'){
           setupVideoPlayer();
        }else if(mediaType == 'image'){
            this.options.includeUI.loadImage.path = Utils.getThumbnailPathfromFileInfo(this.assetDetails);
            try{
              this.hideShowMainCommentSendButton('show');
            }catch(e){console.log(e)}
            this.$nextTick(() => {
                this.isImageAnnotation = true;
                this.isAnnotationEditorVisible = true;
                this.isShowingLoadingDiv = false;
                this.isEditorToolsWrapperVisible = false;
            });
        }
   },
   mounted(){
     parent.document.addEventListener('keypress', this.handleKeyBoardShortcuts);
   },
   beforeDestroy(){
      this.unRegisterforWebsocketNotifications()
      parent.document.removeEventListener('keypress', this.handleKeyBoardShortcuts);
      this.isPlaying = false;
   },
}
</script>

<!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style> -->
<style scoped lang="scss">
   
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-border-color: 1px solid #2b2b2b;
  $icon-hover:#2c3339;
  $border-color: 1px solid #4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555; 
  $input-field-padding:.375rem 10px;
  $filter-border-color: #5a5a5a;
  $filter-bg-color: #2a2a2a;
  $learn-about-text-color-hover:#b7b327;
  $active-green-icon-color: #00ff3a;
  $learn-about-text-color:#9a9620;
  $add-button-text-color:#0b7099;
  $add-button-text-color-hover:#0193cc;
  $add-button-border-color:#b7b228;
  $add-button-border-on-hover:#dcd426;
  $add-button-backgroud:#1e1e1e;
  $duration-color: #01868c;
  $action-bottom-panel-color: #1d2022;
  
  .modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }

 .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height:calc(100vh - 64px);
      padding: 0px 0px 0px 0px;
    //   display:inline-flex;
      width:100%;
      position:relative;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}

.modal-header .close {
    // margin: 0rem -19px -0rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}

.modal-header{
  display: flex;
  align-items: center;
  justify-content: space-between;

}
.modal-footer{
    justify-content: start;
    position: fixed;
    inset-inline-start: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    z-index:9;
}

.close-icon-wrapper{
    position: relative;
    bottom: 1px;
    .close-icon{
        height: 30px !important;
        width: 30px !important;
        color: $dull-text-color !important;
    }
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

.video_annotation_wrapper{
    min-height: 58vh;
    // border: 1px solid red;
    margin: 0 !important;
    padding: 0 !important;
    height: 100%;
}

.video-version-name{
    gap: 37px;
    margin: 0;
    padding-top: 0;
    padding-bottom: 0;
}

.video_wrapper{
    background: #00000082;
    position: relative;
    overflow: hidden;
    overflow-y: auto;
    max-height: calc(100vh - 66px);
    min-height: calc(100vh - 66px);
    display: flex;
    flex-direction: column;
}

.frame-time-code-show{
    position: absolute;
    inset-inline-start: 50%;
    top: 50%;
    transform: translate(-50% , -50%);

    display: flex;
    justify-content: end;
    align-items: flex-start;
    gap: 6px;

    .frame-capture-timecode{
      color: #00d8d9fc;
      font-weight: 900;
      font-size: 16px;
      background: rgba(16, 88, 92, .2901960784313726) !important;
      border: 1px solid #19868c !important;
      padding: 3px 20px;
      border-radius: 5px;
    }
}

.video-control-wrapper{
  //  padding: 9px 15px;
   align-items: center;
   background: $action-bottom-panel-color;
   margin: 0;
   //height: 45px;
   width: 100%;
   display: grid !important;
  //  grid-template-columns: 10% 90%;
   grid-template-columns: 1fr 2fr;
   padding: 7px;
   max-height: 50px;
   position: relative;

   button {
      padding: 4px 12px !important;
      max-height: 33px !important;
      min-height: 33px !important;
      font-size: 14px;
   }
   svg{
      width: 24px !important;
      height: 24px !important;
   }
   .input-group{
      max-height: 33px !important;
      min-height: 33px !important;
   }
}

.svg-tools-color{
  fill: #8f8f8f;
}

.fusion-tui-image-editor-main-wrapper{
    width: 100%;
    height: 69.6vh;
}

.fusion-tui-image-editor-main-wrapper.editor-full-height{
   height: 69.6vh;
}

.fusion-tui-image-editor-main-wrapper.editor-height-with-panel{
  height: calc(100vh - 112px) !important;
}

.active{
    background: $primary-background!important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
    font-weight: 500;
    font-size: 15px;
}

.inactive:hover{
  color:$text-color !important;
}

.inactive{
  color:$text-color !important;
}

.common-input-field{
  margin-inline-start: 3%;
  display: inline-block;
  width: 96%;
  display: inline-block;
  padding: 9px;
  border-radius: 4px;
  background: $primary-background;
  border: $secondary-border-color !important;
  user-select: text !important; 
  cursor:text;
  label{
      width: 30%;
      color: $secondary-text-color;
      word-break: break-word;
  }
  input{
      flex:1;
  }
}

.scroll-highlight-class{
  //  background: $bg-color-on-hover;
   border:2px solid $active-blue !important;
}

.left-control-wrapper,.right-control-wrapper{
  flex-grow: 1;
  flex-basis: 0;
}

.right-control-wrapper{
   justify-content: flex-end;
}


.center-duration-display{
    position: absolute;
    inset-inline-start: 40%;
    display: flex;
    gap: 8px;
    input.form-control{
        background: transparent !important;
        border: 1px solid #4a4a4a !important;
        height: 33px;
        color: #eee;
        padding-top: 8px;
    }
    .input-group-text{
       background-color: transparent !important;
       border: 1px solid #5a5a5a !important;
    }

    .input-group-text img{
        filter: brightness(0.5);
    }

    .input-group {
      //  width: 234px;
      width: 161px;
    }

    .input-group-prepend,.input-group-append{
       height: 33px;
    }

    .input-group-prepend:hover,.input-group-append:hover{
       filter: brightness(1.2);
    }

    // .input-group-append:hover{
    //     border-top-right-radius: 7px !important;
    //     border-bottom-right-radius: 7px !important;
    // }

    .input-group-prepend:hover img,.input-group-append:hover img{
        filter: brightness(1);
    }

}
.right-control-wrapper{
    display: flex;
    gap: 12px;
}

.common-markinmarkout-action-btn.preview,.common-markinmarkout-action-btn.play{
  width:unset;
}

.tui-image-editor {
    inset-inline-start: 0 !important;
}

.tui-image-editor {
    inset-inline-start: 0 !important;
 }

 .center-duration-display input.active-markin-markout-duration{
     background: #10585c4a !important;
     border: 1px solid #19868c !important;
 }

 .center-duration-display .common-markin-markout-input.invalid-duration-value{
    background: #f4433633 !important;
    border: 1px solid #f44336 !important;
 }


//  .video-player-wrapper-div:has(> .vjs-paused) + .video-control-wrapper .center-duration-display{
//    background: red !important;
// }

@keyframes errorShake {
  0% { inset-inline-start :0; }
  20% { inset-inline-start :-6px; }
  40% { inset-inline-start :6px; }
  60% { inset-inline-start :-4px }
  80% { inset-inline-start :4px }
  100% { inset-inline-start :0 }
}

::v-deep{ 

  //Disable comment for now

.common-markin-markout-icon{
   display: none !important;
}

  .video-js.vjs-live .vjs-progress-control {
    display: flex !important;
}

.video-js.vjs-liveui .vjs-progress-control {
    display: flex !important;
}

.video-js.vjs-live-edge .vjs-progress-control {
    display: flex !important;
}

  .col-1.user-name-or-image.user-name{
      max-width: unset !important;
  }

  .final-step-send-comment .main-comment-btn{
      background: #2c6d58 !important;
      border-color: #2c6d58 !important;
      animation: sendCommentBtn 1.5s infinite;
  }

  .v-step__content{
      padding: 0 10px !important;
  }

  .v-step{
    background: #ff5252 !important;
    animation: errorShake 2s ease-in-out;
  }

  .v-step__buttons{
     display: none !important;
  }

 .hide-video-on-browse-open{
     display: none !important;
     z-index: -1;
 }

.text-editor-background-image .main-comment-btn.show{
   visibility: visible !important;
}

.text-editor-background-image .main-comment-btn.hide{
   visibility: hidden !important;
}

.send-review-messages.disable-text-editor{
   opacity: 0.6;
   cursor: not-allowed;
}

.send-review-messages.disable-text-editor > * {
    pointer-events: none;
}

.send-review-messages.disable-text-editor .common-input-field, .send-review-messages.disable-text-editor textarea{
    // background-color: #2c2c2c !important;
    border: 1px solid #444 !important;
    color: #777 !important;
}


// .video-player-wrapper-div:has(> .vjs-paused) + .video-control-wrapper .center-duration-display{
//    background: red !important;
// }

// .video-player-wrapper-div:has(> .vjs-paused){
//    background: red !important;
// }

.center-duration-display .form-control:focus{
   --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0), 0 0 0 5px #00254E;
}

.main-comment-wrapper{
  .textarea-wrapper-for-annotation{
    position:relative;
    transition: all 1s;
 }
  
  .textarea-wrapper-for-annotation:before{
    position: absolute;
      content: "";
      top: 9px;
      inset-inline-start: 13px;
      width: 85px;
      height: 65px;
      z-index: 1;
      background-size: contain;
      background-repeat: no-repeat;
  }

  .textarea-wrapper-for-annotation.make-way-for-thumbnail:after {
      position: absolute;
      top: 6px;
      inset-inline-start: 114px;
      width: 2px;
      background: #2b2b2b;
      height: 69px;
      content: "";
  }
}
.border{
    border: $border-color !important;
}
  
  .active-timeline-marker-bullet{
    border: 2px solid #ffffff;
    width: 10px !important;
   }
  
  .common-markin-markout-icon{
    position: absolute;
    top: -7px;
    font-size: 15px;
    color: #ea4563;
    font-weight: 600;
  }

  .image-border-highlight{
    border: 2px solid #2acfd8;
    filter: brightness(1.5);
  }
   
   #apply_cancel_annotation_panel{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background: $action-bottom-panel-color;
      height: 45px;
      padding: 5px 7px;

      button{
        padding: 4px 12px !important;
        max-height: 33px !important;
        min-height: 33px !important;
        font-size: 14px;
      }
   }

   .video_annotation_wrapper .vjs-progress-control.vjs-control{
      z-index: 99;
      width:100% !important;
   }

  .tui-image-editor-help-menu.right{
      display: none !important;
   }

   .video_annotation_wrapper .vjs-progress-control .user-name-or-image{
      transition: all 1s;
   }

  .video_annotation_wrapper .vjs-progress-control .user-name-or-image:hover{
    transform: scale(1.2);
    z-index:1;
  }

  .video_annotation_wrapper .vjs-progress-control .user-name-or-image:hover  + .annotated-image-thumbnail{
      visibility: visible !important;
      transform: unset !important;
  }

  .highlight-user-timeline{
    transform: scale(1.2);
    z-index:1;
  }
   
   .text-editor-background-image .common-input-field{
      border: unset !important;
   }
   .textarea-wrapper-for-annotation.make-way-for-thumbnail textarea.text-area-with-border{
     padding-inline-start: 119px !important;
   }

   .version-field{
    margin: 0px 10px;
    height: 36px;
    padding: 0px;
    margin-top: 6px;
    .multiselect__tags{
      background: $primary-background;
      border: 1px solid #616161 !important;
    }
    .multiselect__single{
      position: relative;
      bottom: 2px;
      background: $primary-background;
      color: $text-color;
    }
    .multiselect__content {
      background: $secondary-background-color !important;
      border: 1px solid  $bg-color-on-hover !important;
    }
   }

   .multiselect__element:has(.disable-option) {
    /* Add your styles for the parent element here */
    pointer-events: none;
    cursor: none;
    background: #362121;
    opacity: 0.3;
  }

   .version-field-filter{
    min-width:100px;
    height:32px !important;
    min-height: 32px;
    width:auto;
    .multiselect__tags{
      border-radius: 20px;
      height: 32px;
      min-height: 32px;
      padding: 5px 40px 8px 8px!important;
    }
    .multiselect__select {
      line-height: 7px!important;
    }
    .multiselect__placeholder{
      position: relative;
      top: -5px;
    }
    .multiselect__single{
      position: relative;
      bottom: 2px;
      background: $primary-background;
    }
    .multiselect__option--selected{
      background:  $bg-color-on-hover !important;
      color: $text-color;
    }
   }
  .status-field{
    border-radius: 5px;
    .multiselect__select:before{
      border-color: #444444 transparent transparent;
    }
    .multiselect__select{
      background: $primary-background;
      top: -5px !important;
      line-height: 20px !important;
    }
    .multiselect__single{
      background: $primary-background;
      color: $text-color;
    }
    .multiselect__tags{
      border: 0px !important;
      background: inherit !important;
      display: flex;
      align-items: center;
      min-height: 36px !important;
    }
    .multiselect__option--selected{
      background:  $bg-color-on-hover !important;
      color: $text-color;
    }
    .multiselect__content {
      background: $secondary-background-color !important;
      border: 1px solid  $bg-color-on-hover !important;
    }
  }

.modal-body{
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background;
        border: $border-color !important;
        display: flex;
        flex-direction: column;
        align-items: baseline;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      height: unset !important;
    }
    .multiselect__option--selected{
        background:  $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid  $bg-color-on-hover !important;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background;
        padding: 8px 40px 8px 8px !important;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
    .multiselect__content-wrapper{
      border: 1px solid rgb(66, 66, 66) !important;
      background-color: rgb(40, 40, 40) !important;
    }
}

.selected-version-styles{
  .multiselect__single{
    color: $active-blue !important;
  }
}

    .applyYellowColor{
      border: 2px solid #2d99d9;
      height: 36px;
      border-radius: 6px;
      .multiselect__single{
        color: #56c0ff !important;
        position: relative;
        top: -8px;
        margin-bottom: 0px !important;
        font-weight: 500;
      }
      .multiselect__select:before{
        border-color: #56c0ff transparent transparent;
        padding: 0px;
      }
      .multiselect__select{
        top: 4px !important;
        height:22px !important;
      }
    }
    .ApplyRedColor{
      border: 2px solid #b05811;
      height: 36px;
      border-radius: 6px;
      .multiselect__single{
        color: #da7422 !important;
        position: relative;
        top: -8px;
        font-weight: 500;
        margin-bottom: 0px !important;
      }
      .multiselect__select:before{
        border-color: #da7422 transparent transparent;
        padding: 0px;
      }
      .multiselect__select{
        top: 0px !important;
        height:22px !important;
      }
    }
   
   .cancel-review-annotation{
      font-family: "Roboto", Arial, sans-serif !important;
   }

   .annotation-cancel-btn{
      color: #787878;
   }

   .annotation-cancel-btn:hover{
      color: #eee !important;
   }

    #reviewVideoPlayer{
        width: 100% !important;
        height: 100% !important;
    }

  .vjs-marker .reviewer-name-intial-letter{
    top: 20px;
    margin-inline-start: -11px !important;
  }

  .vjs-marker
  {
    position: absolute;
    background: #ea4863;
    width: 3px;
    height: 18px;
    top: -7px;
    z-index: 30;
    margin-inline-start: -3px;
    border-radius: 3px;
    font-size: 14px;
    font-family: "Roboto", Arial, sans-serif !important;
  }

  // .vjs-marker:hover span 
  // {
  //   opacity:1;
  // }

  // .vjs-marker div
  // {
  //   position:absolute;
  //   // bottom:15px;
  //   bottom: -29px;
  //   // opacity:0;
  //   margin-inline-start:-20px;
  //   z-index:90;
  //   background:rgba(0,0,0,.8);
  //   padding:8px;
  //   font-size:10px;
  // } 

   .tui-image-editor-header { display: none !important; }
   .tui-image-editor-container .tui-image-editor-main { top: 0; }
   .tui-image-editor-help-menu.top{display: none !important;}
   .tui-image-editor-virtual-range-pointer{
     background: #fff !important;
   }
   .tie-icon-add-button [data-icontype="icon-star"], [data-icontype="icon-star-2"]{
      display: none !important;
   }
   .tui-image-editor-menu-icon .tui-image-editor-partition, .tui-image-editor-menu-icon .tie-icon-add-button:not(:first-child){
      display: none !important;
   }

   .cancel-review-annotation{
      display: inline-block;
      float: inline-end;
      position: relative;
      inset-inline-end: 16px;
      // top: 7px;
      top: 12px;
   }

   .tui-image-editor-item.custom-added{
      top: 9px !important;
      display: none !important;
    }

    html{
      overflow-y:auto !important;
    }

    .tui-image-editor-submenu{
        visibility: hidden;
        transition: transform 0.6s cubic-bezier(0.83, 0, 0.17, 1);
    }

    .tui-image-editor-controls:hover + .tui-image-editor-main-container  .tui-image-editor-submenu{
        visibility: visible !important;  
    } 

    .tui-image-editor-submenu:hover {
        visibility: visible !important;
    }

    .tui-image-editor-main-container{
       background-color: #00000091 !important;
    }

    .tui-image-editor-controls{
       background-color: #1a1e21 !important;
    }

    // .tui-image-editor-container{
    //     width: 100%;
    //     height: 100%;
    //     position: absolute;
    //     top: 0;
    //     inset-inline-start :0;
    //     z-index: 9999999999;
    // }


  .tui-image-editor-menu {
      width: auto;
      list-style: none;
      padding: 0;
      margin: 0 auto;
      display: table-cell;
      text-align: center;
      vertical-align: middle;
      white-space: nowrap;
  }

.tui-image-editor-item {
    position: relative;
    display: inline-block;
    border-radius: 2px;
    padding: 7px 8px 3px 8px;
    cursor: pointer;
    margin: 0 4px;
    margin-bottom: 12px !important;
}

.tui-image-editor-item svg{
   width: 24px;
   height: 24px;
}

.tui-image-editor-menu use.normal.use-default, .tui-image-editor-help-menu use.normal.use-default {
    fill-rule: evenodd;
    fill: #8a8a8a;
    stroke: #8a8a8a;
}

.video-player-wrapper-div .vjs-play-control{
   display: none !important;  
}

.video-player-wrapper-div .vjs-fullscreen-control{
      display: none !important;
 }

 .video-player-wrapper-div .vjs-control-bar{
    display: flex !important;
    opacity:1 !important;
  }

  .video-js .vjs-play-progress:before{
      font-size: 1.8em !important;
      z-index: 9 !important;
      top: -0.43333333333em;
      color: #28cfd8;
  }

.video-player-wrapper-div .video-js .vjs-play-progress{
  background-color: #28cfd8;
}
  
  .send-review-messages {
      display:flex;
      justify-content: center;
      height: calc(40% - 101px);
      background: #1a1e21;
      border: 1px solid #333;
      flex: 1;

      .common-input-field{
        margin: 0 !important;
        width: 100% !important;
      }

     textarea{
        min-height: 87px !important; 
     }
  }

  .image-review-display{
     height: calc(40% - 81px) !important;
  }
  
  
  .video-player-wrapper-div{
    min-height: 66% !important;
    max-height: 66% !important;
    height: 66% !important;
  }

  .player-loading-progress-div{
     width: 100%;
    color: #b9b0b0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
  }

  .custom-annotation-button-wrapper{
      display: flex;
      gap: 8px;

      button{
          font-family: "Roboto", Arial, sans-serif !important;
          //font-size: 12px !important;
          padding: 5px 21px;
      }
  }

  .tui-image-editor {
      inset-inline-start: 0 !important;
  }

}  //end of v:deep

.video-version-name .version-info{
   color: #6a6969;
}


.primary-btn-style{
    text-align: end;
    button{
        font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}

.config-value {
  // margin-inline-start: 4px;
  // display: grid;
  display:flex;
  align-items: center;
  svg{
      position: relative;
      top: 9px;
      margin-inline-start: 10px;
  }
}

.user-name-or-image{
  top:0px !important;
  margin-inline-end:2px;
  // transition: all 1s;
}

.review-annotation-wrapper{
  height: 100%;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.review-heading-input::placeholder {
  font-size:28px !important;
  font-weight: 100 !important;
  color: $secondary-text-color !important;
}

.review-title-heading{ 
  margin:0px !important;
  width:50%;
  height: 45px;
  input{
    color:$text-color;
    height:100%;
    width:100% !important;
    padding-inline-start:10px !important;
    padding-top: 11px;
    border-radius: 5px;
    font-size: 25px;
  }
}  

.comm-input-field-style{
    background: $primary-background!important;
    width: 70% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: 100%;
}

.edit-icon-visibility{
    width: 100%;
    .edit-icon{
      visibility: hidden;
    }
}

.edit-icon-visibility:hover{
    .edit-icon{
        visibility: visible;
    } 
}

.add-assignees-dropdown{
    width: 38px;
    height: 34px;
    border: 1px solid $add-button-border-color;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    background: #1e1e1e;
    margin-inline-end: 3px;
    svg{
      fill: #36c5ff;
    }
}

.add-assignees-dropdown:hover{
    border: 1px solid $add-button-border-on-hover; 
    svg{
      fill: $add-button-text-color-hover;
    }
}

.common-input-field{
    margin-inline-start: 3%;
    width: 96%;
    display: flex;
    flex-direction: column;
    padding: 9px;
    border-radius: 4px;
    background: $primary-background;
    label{
        width: 30%;
        color: $dull-text-color;
        word-break: break-word;
    }
    .comm-input-field-style{
      width: 100% !important;
    }
}

textarea:focus{
    outline: none;
    bottom: 0px;
    inset-inline-start: 0px;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}

.reviewTitleSaveUnsaveBtns{
  svg{
    color: $text-color;
    border: $border-color;
    background: $primary-background;
    margin-inline-end: 2px;
    height: 30px;
    width: 30px;
    margin-inline-start: 4px;
  }
}

.description-edit-icon-visibility:hover{
  .description-options-wrapper{
    visibility: visible;
  }
}

.description-options-wrapper:hover{
  svg{
    fill: $text-color;
    background: $secondary-background-color;
  }
} 

.description-options-wrapper{
    visibility: hidden;
    position: absolute;
    inset-inline-end: 10px;
    top: 4px;
    border: 1px solid #5a5a5a;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:2px;
    cursor: pointer;
    svg{
       width: 22px;
        height: 22px;
        padding: 3px;
        // margin: 3px 0px 3px 3px;
        border-radius: 4px;
    }
}

.descriptionSaveUnsaveBtns{
  position: relative;
  top: 9px;
}

.comment-row-wrapper{
    border: $secondary-border-color;
    border-radius: 5px;
    margin:3px;
    position: relative;
}

.commentedOn-duration{
  height: 20px;
  padding: 10px 10px;
  display: flex;
  align-items: center;
  font-size: 12px;
  border-radius: 3px;
  background: $duration-color;
  width: 60px;
  margin: 5px 2px;
}

.delete-user-icon{
  visibility: hidden;
}
.comm-users-class:hover .delete-user-icon{
  visibility: visible;
}
.comm-users-class{
  position: relative;
}

.delete-user-icon{
  position: absolute;
  inset-inline-end: 0px;
  top: -4px;
  height: 20px;
  width: 20px;
  border: $border-color;
  background: $secondary-background-color;
  border-radius: 30px;
  color: $text-color;
}

.active-commentRow{
  .comment-parent-row-wrapper{
    background: $bg-color-on-hover;
  }
}

.reviewers-with-status{
  display:flex;
}

.approvedUsers-wrapper, .reviewersUsers-wrapper{
  border-radius: 5px;
  height: 34px;
  align-items: center;
  margin-inline-end: 5px;
  padding: 2px;
}

.reviewersUsers-wrapper{
  border: 1px solid #e09b4f;
}

.approvedUsers-wrapper{
  border: 1px solid #0dae0d;
  svg{
    position: relative;
    inset-inline-end: 2px;
  }
}

.done-text{
    height: 32px;
    width: 59px;
    border: 2px solid #a2b215;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #d4d800;
}

.background-color-for-reviewers{
  background: $primary-background;
}
.outer {
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.middle {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.inner {
  margin-inline-start: auto;
  margin-inline-end: auto;
  height: 138px;
  margin-bottom:10%;
  svg{
    height:55%;
    width: 45%;
  }
  p{
    text-align: center;
    color: #666;
    font-size: 18px;
  }
}

.multiselect__single{
  justify-content: flex-end !important;
}

.versions-filter-wrapper{
  width: 100%;
  padding: 5px;
  display: flex;
  .version-tags{
    border-radius: 20px;
    padding: 4px 14px;
    display: flex;
    align-items: center;
    margin-inline-end: 7px;
    color: #9c9c9c;
    border: 1px solid #3a3a3a;
    height:32px;

  }
}

.highlight-on-hover:hover{
  fill: #eee;
}
.activeFilter{
  color: #007bfc!important;
}

.disable-option{
  pointer-events: none;
  opacity: 0.6;
}

.left-control-wrapper, .markin-markout-with-comments, .comment-with-frame, .comment-with-segement-markin-markout {
    display: flex;
}

.comment-with-segement-markin-markout{
    display: flex;
    gap: 8px;
}

// .comment-with-frame button{
//     background: rgb(165, 71, 18) !important;
//     color: #fff;
//     border-width: 1px !important;
//     border-style: solid !important;
//     border-color: rgb(165, 71, 18) !important;
// }

.markin-markout-with-comments{
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: end;
}

@keyframes blink {
    0% {
      box-shadow: 0 0 0 0 rgba(0, 123, 255 , 0.8);
    }
    50% {
      box-shadow: 0 0 0 10px rgba(0, 82, 204, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(0, 82, 204, 0);
    }
}

@keyframes framePulseBtn {
    0% {
      box-shadow: 0 0 0 0 rgba(25, 134, 140, 0.7);
    }
    50% {
      box-shadow: 0 0 0 10px rgba(0, 82, 204, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(0, 82, 204, 0);
    }
}

@keyframes sendCommentBtn {
    0% {
      box-shadow: 0 0 0 0 rgba(44, 109, 88, 0.7);
    }
    50% {
      box-shadow: 0 0 0 10px rgba(0, 82, 204, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(0, 82, 204, 0);
    }
}


// .capture-frame-btn{
//     border-width: 1px !important;
//     border-style: solid !important;
//     border-color: rgb(165, 71, 18) !important;
//     border-image: initial !important;
//     background: rgb(165, 71, 18) !important;
//     animation: framePulseBtn 1.5s infinite;
// }

.active-pulsate-btn{
  animation: blink 1.5s infinite;
}

.input-group-append,.input-group-prepend{
    color: #fff;
    border-radius: 2px;
    border: 1px solid #19868c !important;
    background: #19868c !important;
    #markout-add-on,#markin-add-on{
       border: none !important;
    }
}

.input-group.markout .input-group-append.is-markout-not-added{
    animation: framePulseBtn 1.5s infinite;
}

.input-group.markout .input-group-append img, .input-group.markin .input-group-prepend img{
   filter: brightness(1);
}

//Disable comment for now

.common-markin-markout-icon{
   display: none !important;
}

</style>
